import * as tslib_1 from "tslib";
// Core packages
import { ElementRef, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
// Third party packages
import { formatDate } from "@angular/common";
import { MatDialog } from "@angular/material";
import { TranslateService } from "@ngx-translate/core";
import * as FileSaver from "file-saver";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import { finalize, take } from "rxjs/operators";
// Custom packages
import { AuthService } from "src/app/modules/auth/auth.service";
import { CompaniesService } from "src/app/modules/companies/companies.service";
import { ExportContractsDialogComponent } from 'src/app/modules/properties/components/export-contracts-dialog/export-contracts-dialog.component';
import { ExportRasDocsDialogComponent } from 'src/app/modules/properties/components/export-ras-docs-dialog/export-ras-docs-dialog.component';
import { ConductorManagementDialogComponent } from 'src/app/modules/properties/components/conductor-management-dialog/conductor-management-dialog.component';
import { InterventionArchivingDialogComponent } from 'src/app/modules/properties/components/intervention-archiving-dialog/intervention-archiving-dialog.component';
import { PropertiesService } from "src/app/modules/properties/properties.service";
import { RolesService } from "src/app/modules/roles/roles.service";
import { SettingsService } from "src/app/modules/settings/settings.service";
import { SuppliersService } from "src/app/modules/suppliers/suppliers.service";
import { ConfirmDialogComponent } from "src/app/shared/components/dialogs/confirm-dialog/confirm-dialog.component";
import { ViewStructureDialogComponent } from "src/app/shared/components/dialogs/view-structure-dialog/view-structure-dialog.component";
import { Company } from "src/app/shared/models/company/company.model";
import { Property } from "src/app/shared/models/property/property.model";
import { ApiService } from "src/app/shared/services/api.service";
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from "src/app/shared/services/helper.service";
import { ThemeService } from "src/app/shared/services/theme.service";
import { CancelContractDialogComponent } from "../../components/cancel-contract-dialog/cancel-contract-dialog.component";
import { PropertyExpireContractItemDialogComponent } from "../../components/contract-expire-item-dialog/contract-expire-item-dialog.component";
import { PropertyDeleteDocumentItemDialogComponent } from "../../components/document-delete-item-dialog/document-delete-item-dialog.component";
import { DocumentDownloadDialogComponent } from "../../components/document-download-dialog/document-download-dialog.component";
import { PropertyDetailDocumentInsertDialogComponent } from "../../components/document-insert-dialog/document-insert-dialog.component";
import { PropertyDetailDocumentItemDialogComponent } from "../../components/document-item-dialog/document-item-dialog.component";
import { PropertyDetailDocumentItemPrintDialogComponent } from "../../components/document-item-print-dialog/document-item-print-dialog.component";
import { PropertyDetailDocumentNoteDialogComponent } from "../../components/document-note-dialog/document-note-dialog.component";
import { DocumentPaperInsertDialogComponent } from "../../components/document-paper-insert-dialog/document-paper-insert-dialog.component";
import { PropertyDetailDocumentPrintModuleDialogComponent } from "../../components/document-print-module-dialog/document-print-module-dialog.component";
import { PropertySameCodeEditDialogComponent, } from "../../components/document-same-code-edit-dialog/document-same-code-edit-dialog.component";
import { SendEmailDialogComponent } from "../../components/send-email-dialog/send-email-dialog.component";
import { CondoStructuresService } from "../../condo-structures.service";
import { DocumentArchivesService } from "../../document-archives.service";
import DocumentTypeStructure from "../../documentTypes";
import { buildSameCodeChoices, buildSameCodeEditTargets, collectSameCodeFormFields, } from "../../same-code-docs-edit.utils";
import { applySanitaryWaterMeterNames, getSanitaryWaterMeterNames, } from "../../sanitary-water-meters.utils";
var PropertyDocumentsComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function PropertyDocumentsComponent(dialog, newMessageDialog, cancelContractDialog, configService, activatedRoute, propertiesService, router, toastrService, translateService, themeService, authService, cookieService, apiService, // DO NOT MOVE since it's used for 'autocomplete' field type
    condoStructuresService, rolesService, helperService, documentArchivesService, companiesService, suppliersService, settingsService) {
        this.dialog = dialog;
        this.newMessageDialog = newMessageDialog;
        this.cancelContractDialog = cancelContractDialog;
        this.configService = configService;
        this.activatedRoute = activatedRoute;
        this.propertiesService = propertiesService;
        this.router = router;
        this.toastrService = toastrService;
        this.translateService = translateService;
        this.themeService = themeService;
        this.authService = authService;
        this.cookieService = cookieService;
        this.apiService = apiService;
        this.condoStructuresService = condoStructuresService;
        this.rolesService = rolesService;
        this.helperService = helperService;
        this.documentArchivesService = documentArchivesService;
        this.companiesService = companiesService;
        this.suppliersService = suppliersService;
        this.settingsService = settingsService;
        this.subscriptions = [];
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        this.loggedUserRoleType = "";
        // Could not be "Property" type because in "get" method in the back-end
        // We are populating some fields, so the model is not the same!
        this.property = new Property();
        this.propertyId = "";
        this.loggedUserShared = false;
        this.loggedUserTemporary = false;
        this.loggedUserMaster = false;
        this.loggedUserAdmin = false;
        this.activeSectionData = [];
        this.allDocs = [];
        this.displayedDocs = [];
        this.documentsStructure = [];
        this.sortedDocuments = [];
        this.documentTypeStructure = new DocumentTypeStructure();
        this.documentArchiveIsLoading = true;
        // "Modifica dati aggiuntivi": lookup of the rows sharing the code still running
        this.sameCodeLookupInProgress = false;
        this.showDocumentsExpired = true;
        this.showDocumentsNotInserted = true;
        this.showStructureDeleted = false;
        this.showDocumentsNotVirtual = true;
        // insertDocuments = false;
        // insertDocumentsSelected = false;
        // insertDocumentsSelectedKey: any[] = [];
        this.company = new Company();
        this.pageIsLoading = true;
        this.insertedDocs = [];
        this.selectedDocs = [];
        this.editDocument = true;
        this.totMandatoryDocs = 0;
        this.totInsertDocs = 0;
        this.totNotInsertDocs = 0;
        this.totOptionalDocs = 0;
        this.totDocs = 0;
        this.progressBarVal = 0;
        this.progressBarValStyle = { width: "0px" };
        this.subscriptionType = "FULL";
        this.structureSelected = [];
        this.showSideMenu = true;
        this.sortActive = false;
        this.companyData = {};
        this.propertyName = "";
        // Dati aggiuntivi elenco/nuovo elemento
        this.suppliersName = [];
        this.yearsOfStorage = [];
        this.conductorName = [];
        this.nameInterventionArchiving = [];
        this.documentTemplateId = "";
        this.documentTemplate = [];
        this.notesExist = false;
        this.condoStructureTemplate = [];
        this.masterAndSubscriptionPrivacy = false;
        this.originalOrder = function (a, b) {
            return 0;
        };
        // this.documentsStructure = DocumentsStructure;
    }
    /**
     * Init components
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Set page title
        this.themeService.setPageTitle(this.translateService.instant("properties.documentsPage.pageTitle"));
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) {
            _this.loggedUser = res;
            var currentRole = _this.loggedUser.userRoles.find(function (obj) {
                return (obj._id.toString() ===
                    _this.authService.loggedUserRequestedRole$.getValue().toString());
            });
            _this.loggedUserRoleType = currentRole.role.type;
        }));
        this.subscriptions.push(this.authService.loggedUserPermissions$.subscribe(function (res) { return (_this.loggedUserPermissions = res); }));
        this.subscriptions.push(this.authService.loggedUserRequestedRoleObj$.subscribe(function (res) { return (_this.loggedUserObj = res); }));
        // Get logged user's role data
        this.currentRole = this.loggedUser.userRoles.find(function (obj) {
            return (obj._id.toString() ===
                _this.authService.loggedUserRequestedRole$.getValue().toString());
        });
        this.loggedUserRole = this.currentRole.role;
        if (this.currentRole.role.type === "shared") {
            this.loggedUserShared = true;
            this.showDocumentsExpired = false;
            this.showDocumentsNotInserted = false;
            this.showDocumentsNotVirtual = true;
        }
        if (this.currentRole.role.type === "temporary") {
            this.loggedUserTemporary = true;
            this.showDocumentsExpired = false;
            this.showDocumentsNotInserted = true;
            if (typeof this.currentRole.propertiesPermission.docsInserted !== "undefined"
                && this.currentRole.propertiesPermission.docsInserted) {
                this.showDocumentsNotInserted = false;
            }
            this.showDocumentsNotVirtual = true;
        }
        if (this.currentRole.role.type === "master" ||
            this.currentRole.role.type === "collaborator") {
            this.loggedUserMaster = true;
            if (this.currentRole.company._id !== "") {
                this.subscriptions.push(this.companiesService
                    .get(this.currentRole.company._id)
                    .subscribe(function (res) {
                    if (res.status) {
                        _this.companyData = res.data;
                    }
                }));
            }
        }
        this.loggedUserAdmin =
            this.loggedUserRole.type === "admin" ||
                this.loggedUserRole.type === "operator";
        // Get current lang
        this.lang =
            this.cookieService.get("lang") || this.configService.defaultLang;
        this.subscriptions.push(this.settingsService.getStructure().subscribe(function (res) {
            if (res.status) {
                if (res.condoStructureTemplate &&
                    Array.isArray(res.condoStructureTemplate) &&
                    res.condoStructureTemplate.length > 0 &&
                    res.condoStructureTemplate[0].area &&
                    Array.isArray(res.condoStructureTemplate[0].area)) {
                    _this.condoStructureTemplate = res.condoStructureTemplate[0].area;
                }
            }
        }));
        // Get requested property data, company data and document archive
        this.propertyId = this.activatedRoute.snapshot.params.propertyId;
        this.subscriptions.push(this.propertiesService.get(this.propertyId).subscribe(function (res) {
            if (res.status) {
                _this.property.setData(res.data);
                _this.propertyData = res.data;
                _this.propertyName = res.data.name;
                if (_this.propertyData &&
                    _this.propertyData.subscription &&
                    _this.propertyData.subscription.key) {
                    _this.subscriptionType = _this.propertyData.subscription.key;
                    if (_this.subscriptionType === 'PRIVACY' && _this.loggedUserMaster) {
                        _this.masterAndSubscriptionPrivacy = true;
                    }
                }
                if (_this.propertyData.admin &&
                    _this.propertyData.admin.company &&
                    _this.propertyData.admin.company._id) {
                    _this.subscriptions.push(_this.companiesService
                        .get(_this.propertyData.admin.company._id)
                        .subscribe(function (res) {
                        if (res.status) {
                            _this.company.setData(res.data);
                        }
                    }));
                }
                // If property has a structure ID, than retrive related data
                // and document archive
                if (_this.subscriptionType !== "FREE" &&
                    _this.subscriptionType !== "FREEBASIC" &&
                    _this.propertyData.structure) {
                    // // Hide all visible elements of side menu
                    // for (const key in this.documentsStructure) {
                    //   this.documentsStructure[key].visible = false;
                    //   if (Array.isArray(this.documentsStructure[key].content)) {
                    //     this.documentsStructure[key].content.forEach((el: any) => {
                    //       el.visible = false;
                    //     });
                    //   }
                    // }
                    _this.subscriptions.push(_this.settingsService.getDocument().subscribe(function (res) {
                        if (res.status) {
                            if (res.data &&
                                Array.isArray(res.data) &&
                                res.data.length > 0 &&
                                res.data[0].area &&
                                Array.isArray(res.data[0].area)) {
                                _this.documentTemplateId = res.data[0]._id;
                                _this.documentTemplate = res.data[0].area;
                                _this.documentsStructure = _this.documentTemplate.map(function (elDT) {
                                    var subEl = [];
                                    if (Array.isArray(elDT.content)) {
                                        subEl = elDT.content.map(function (subElDT) {
                                            return {
                                                title: subElDT.title,
                                                translation: subElDT.translation,
                                                type: subElDT.type,
                                                expanded: subElDT.expanded,
                                                section: subElDT.section,
                                                visible: subElDT.visible,
                                                key: subElDT.key,
                                            };
                                        });
                                    }
                                    return {
                                        title: elDT.title,
                                        translation: elDT.translation,
                                        type: elDT.type,
                                        section: "",
                                        buttonTitle: "",
                                        expanded: elDT.expanded,
                                        icon: "",
                                        visible: elDT.visible,
                                        content: subEl,
                                    };
                                });
                                // Hide all visible elements of side menu
                                for (var key in _this.documentsStructure) {
                                    _this.documentsStructure[key].visible = false;
                                    if (Array.isArray(_this.documentsStructure[key].content)) {
                                        _this.documentsStructure[key].content.forEach(function (el) {
                                            el.visible = false;
                                        });
                                    }
                                }
                                _this.getStructureData();
                            }
                        }
                    }, function (err) {
                        //
                    }));
                    // this.getStructureData();
                }
                else if (_this.subscriptionType === "FREE" || _this.subscriptionType === "FREEBASIC") {
                    _this.subscriptions.push(_this.settingsService.getDocument().subscribe(function (res) {
                        if (res.status) {
                            if (res.data &&
                                Array.isArray(res.data) &&
                                res.data.length > 0 &&
                                res.data[0].area &&
                                Array.isArray(res.data[0].area)) {
                                _this.documentTemplateId = res.data[0]._id;
                                _this.documentTemplate = res.data[0].area;
                                _this.documentsStructure = _this.documentTemplate.map(function (elDT) {
                                    var subEl = [];
                                    if (Array.isArray(elDT.content)) {
                                        subEl = elDT.content.map(function (subElDT) {
                                            return {
                                                title: subElDT.title,
                                                translation: subElDT.translation,
                                                type: subElDT.type,
                                                expanded: subElDT.expanded,
                                                section: subElDT.section,
                                                visible: subElDT.visible,
                                                key: subElDT.key,
                                            };
                                        });
                                    }
                                    return {
                                        title: elDT.title,
                                        translation: elDT.translation,
                                        type: elDT.type,
                                        section: "",
                                        buttonTitle: "",
                                        expanded: elDT.expanded,
                                        icon: "",
                                        visible: elDT.visible,
                                        content: subEl,
                                    };
                                });
                                // Show all elements of side menu
                                for (var key in _this.documentsStructure) {
                                    _this.documentsStructure[key].visible = true;
                                    if (Array.isArray(_this.documentsStructure[key].content)) {
                                        _this.documentsStructure[key].content.forEach(function (el) {
                                            el.visible = true;
                                        });
                                    }
                                }
                                // If property has a document Archive ID, than retrive related data
                                if (_this.propertyData.documentArchive) {
                                    _this.documentArchiveId = _this.propertyData.documentArchive;
                                    _this.getDocumentArchiveDataFree();
                                    _this.pageIsLoading = false;
                                }
                            }
                        }
                    }, function (err) {
                        //
                    }));
                }
                else {
                    _this.documentArchiveIsLoading = false;
                }
                _this.pageIsLoading = false;
                return;
            }
            // Something bad happened
            // redirect user to home
            _this.router.navigate([_this.lang, "app", "properties", "list"]);
        }, function (err) {
            // if we came here users with given userId do not exist
            _this.router.navigate([_this.lang, "errors", "404"]);
        }));
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Get courrent property structure data and populate
     * this.condoStructure.
     * Then get archive document.
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.getStructureData = function () {
        var _this = this;
        this.condoStructuresService
            .get(this.property.get("structure"))
            .subscribe(function (res) {
            if (res.status) {
                _this.condoStructure = res.data;
                if (_this.condoStructure.open) {
                    _this.editDocument = false;
                }
                for (var key in _this.condoStructure) {
                    if (Array.isArray(_this.condoStructure[key]) &&
                        _this.condoStructure[key].length) {
                        _this.condoStructure[key].every(function (el) {
                            if (el.note && Array.isArray(el.note) && el.note.length) {
                                _this.notesExist = true;
                                return false;
                            }
                        });
                        if (_this.notesExist) {
                            break;
                        }
                    }
                }
                // If property has a document Archive ID, than retrive related data
                if (_this.propertyData.documentArchive) {
                    _this.documentArchiveId = _this.propertyData.documentArchive;
                    _this.getDocumentArchiveData();
                    _this.pageIsLoading = false;
                }
            }
            else {
                _this.documentArchiveIsLoading = false;
                _this.toastrService.error(res.message);
            }
        });
    };
    /**
     * Get current property documentArchive data and populate
     * this.documentArchive
     * this.allDocs is used to show all docs in page
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.getDocumentArchiveData = function () {
        var _this = this;
        this.documentArchiveIsLoading = true;
        this.insertedDocs = [];
        this.documentArchivesService
            .get(this.property.get("documentArchive"))
            .subscribe(function (res) {
            if (res.status) {
                _this.documentArchive = res.data;
                if (_this.documentArchive.suppliersName) {
                    _this.suppliersName = _this.documentArchive.suppliersName;
                }
                if (_this.documentArchive.yearsOfStorage) {
                    _this.yearsOfStorage = _this.documentArchive.yearsOfStorage;
                }
                if (_this.documentArchive.conductorName) {
                    _this.conductorName = _this.documentArchive.conductorName;
                }
                if (_this.documentArchive.nameInterventionArchiving) {
                    _this.nameInterventionArchiving =
                        _this.documentArchive.nameInterventionArchiving;
                }
                _this.allDocs = _this.documentTypeStructure.getDocumentArchiveData(_this.lang, _this.documentTemplate, _this.condoStructure, _this.documentArchive, _this.subscriptionType, _this.insertedDocs, true);
                // The last argument above keeps the soft deleted documents of deleted structures
                // in the tree. Only the rows already queued for the hard delete cron are dropped
                // here: that queue marks a manual deletion, so a document deleted from this page
                // does not come back after the reload, while the rows soft deleted by the cascade
                // of a removed mapping element stay and keep their deleted structure visible.
                _this.removeHardDeletedDocs(_this.allDocs);
                // ND1, ND2, ND25 and ND26 belong to the property and carry no meter: their rows
                // get the names of the sanitary water meters that make them due, printed in
                // parentheses in their section and in the Contratti table.
                applySanitaryWaterMeterNames(_this.allDocs, getSanitaryWaterMeterNames(_this.condoStructure));
                // Only Privacy
                if (_this.subscriptionType === 'PRIVACY' &&
                    !_this.loggedUserAdmin) {
                    _this.allDocs = _this.allDocs.filter(function (el) { return el.keyTranslateTitle === "properties.documents.gestionaleAmministrativo"; });
                    _this.allDocs.forEach(function (el) {
                        if (Array.isArray(el.content)) {
                            el.content = el.content.filter(function (subEl) {
                                return subEl.keyTranslateTitle === "properties.documents.Aprivacy" ||
                                    subEl.keyTranslateTitle === "properties.documents.gestAmmTivoDipendenti" ||
                                    subEl.keyTranslateTitle === "properties.documents.gestAmmTivoGestionali";
                            });
                        }
                    });
                    _this.allDocs.forEach(function (el) {
                        if (Array.isArray(el.content)) {
                            el.content.forEach(function (subel) {
                                if (subel.type === "doc" && Array.isArray(subel.content)) {
                                    subel.content = subel.content.filter(function (subEl) {
                                        return subEl.privacy;
                                    });
                                }
                                else if (subel.type === "title" && Array.isArray(subel.content)) {
                                    subel.content.forEach(function (subsubel) {
                                        if (Array.isArray(subsubel.content)) {
                                            subsubel.content = subsubel.content.filter(function (subsubEl) {
                                                return subsubEl.privacy;
                                            });
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
                var filteredData = [];
                if (_this.allDocs && Array.isArray(_this.allDocs)) {
                    filteredData = _this.filterDisplayedDocs(_this.allDocs);
                }
                _this.displayedDocs = filteredData;
                _this.countDocPerArea();
            }
            else {
                _this.toastrService.error(res.message);
            }
            _this.documentArchiveIsLoading = false;
        });
    };
    /**
     * Only for FREE subscription
     * Get current property documentArchive data and populate
     * this.documentArchive
     * this.allDocs is used to show all docs in page
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.getDocumentArchiveDataFree = function () {
        var _this = this;
        this.documentArchiveIsLoading = true;
        this.insertedDocs = [];
        this.documentArchivesService
            .get(this.property.get("documentArchive"))
            .subscribe(function (res) {
            if (res.status) {
                _this.documentArchive = res.data;
                if (_this.documentArchive.suppliersName) {
                    _this.suppliersName = _this.documentArchive.suppliersName;
                }
                if (_this.documentArchive.yearsOfStorage) {
                    _this.yearsOfStorage = _this.documentArchive.yearsOfStorage;
                }
                if (_this.documentArchive.conductorName) {
                    _this.conductorName = _this.documentArchive.conductorName;
                }
                if (_this.documentArchive.nameInterventionArchiving) {
                    _this.nameInterventionArchiving =
                        _this.documentArchive.nameInterventionArchiving;
                }
                _this.allDocs = _this.documentTypeStructure.getDocumentArchiveDataFree(_this.lang, _this.documentTemplate, _this.documentArchive, _this.subscriptionType, _this.insertedDocs);
                var filteredData = [];
                if (_this.allDocs && Array.isArray(_this.allDocs)) {
                    filteredData = _this.filterDisplayedDocs(_this.allDocs);
                }
                _this.displayedDocs = filteredData;
                _this.countDocPerArea();
            }
            else {
                _this.toastrService.error(res.message);
            }
            _this.documentArchiveIsLoading = false;
        });
    };
    /**
     * Utility: extracts documents from one section of documentArchive
     * and show the documents into page
     * in getDocumentArchiveData()
     *
     * array of documents
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.getDocsFromSection = function (section) {
        var _this = this;
        var docList = [];
        var _loop_1 = function (doc) {
            if (section.documents[doc].length) {
                section.documents[doc].forEach(function (item) {
                    if (!item.deleted) {
                        if (item.data &&
                            item.data.nomeSocietaEroganteInServizio &&
                            // (item.data.rilasciatoFirmatoDa ||
                            //   item.data.nomeDiRiferimento ||
                            //   item.data.nomeSocietaEroganteInServizio ||
                            //   item.data.nomeConduttore ||
                            //   item.data.ragioneSocialeCostruttore ||
                            //   item.data.daNome ||
                            //   item.data.riferimentoComuneASL ||
                            //   item.data.nomeAmministratoreDelCondominio ||
                            //   item.data.nomeIdentificativoDellaReteDiTeleriscaldamento ||
                            //   item.data.aFirmaDi ||
                            //   item.data.nomeFornitore) &&
                            typeof item.data.ragioneSocialeFornitore === "undefined") {
                            if (item.data.rilasciatoFirmatoDa) {
                                item.data["ragioneSocialeFornitore"] =
                                    item.data.rilasciatoFirmatoDa;
                            }
                            else if (item.data.nomeDiRiferimento) {
                                item.data["ragioneSocialeFornitore"] =
                                    item.data.nomeDiRiferimento;
                            }
                            else if (item.data.nomeConduttore) {
                                item.data["ragioneSocialeFornitore"] = item.data.nomeConduttore;
                            }
                            else if (item.data.ragioneSocialeCostruttore) {
                                item.data["ragioneSocialeFornitore"] =
                                    item.data.ragioneSocialeCostruttore;
                            }
                            else if (item.data.daNome) {
                                item.data["ragioneSocialeFornitore"] = item.data.daNome;
                            }
                            else if (item.data.riferimentoComuneASL) {
                                item.data["ragioneSocialeFornitore"] =
                                    item.data.riferimentoComuneASL;
                            }
                            else if (item.data.nomeAmministratoreDelCondominio) {
                                item.data["ragioneSocialeFornitore"] =
                                    item.data.nomeAmministratoreDelCondominio;
                            }
                            else if (item.data.nomeIdentificativoDellaReteDiTeleriscaldamento) {
                                item.data["ragioneSocialeFornitore"] =
                                    item.data.nomeIdentificativoDellaReteDiTeleriscaldamento;
                            }
                            else if (item.data.aFirmaDi) {
                                item.data["ragioneSocialeFornitore"] = item.data.aFirmaDi;
                            }
                            else if (item.data.nomeFornitore) {
                                item.data["ragioneSocialeFornitore"] = item.data.nomeFornitore;
                            }
                            else {
                                item.data["ragioneSocialeFornitore"] =
                                    item.data.nomeSocietaEroganteInServizio;
                            }
                        }
                        if (item.data && item.data.barCode) {
                            if (item.data.barCode.length > 6) {
                                item.data["docCode"] = item.data.barCode.substring(item.data.barCode.length - 7, item.data.barCode.length - 1);
                            }
                        }
                        docList.push({
                            title: _this.translateService.instant("properties.documents.titles." + doc),
                            type: "doc",
                            docId: item._id,
                            key: doc,
                            mandatory: (_this.subscriptionType === "FREE" || _this.subscriptionType === "FREEBASIC") ? false : item.mandatory,
                            expired: item.expired,
                            deleted: item.deleted,
                            dateExpired: item.dateExpired,
                            contract: item.contract,
                            pdfmsg: item.pdfmsg,
                            data: item.data,
                            checked: false,
                        });
                    }
                    if (!item.deleted && item.data) {
                        _this.insertedDocs.push({
                            title: _this.translateService.instant("properties.documents.titles." + doc),
                            docId: item._id,
                            data: item.data,
                            checked: false,
                        });
                    }
                });
            }
        };
        for (var doc in section.documents) {
            _loop_1(doc);
        }
        docList.sort(this.compareExpired);
        return docList;
    };
    /**
     * Utility: extracts only contracts from one section of documentArchive
     * and show the documents into page
     * in getDocumentArchiveData()
     *
     * array of documents
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.getDocsFromContractSection = function (section, keyTranslateTitle) {
        var _this = this;
        var docList = [];
        var _loop_2 = function (doc) {
            if (section.documents[doc].length) {
                section.documents[doc].forEach(function (item) {
                    if (item.contract) {
                        if (!item.deleted) {
                            if (item.data &&
                                item.data.nomeSocietaEroganteInServizio &&
                                // (item.data.rilasciatoFirmatoDa ||
                                //   item.data.nomeDiRiferimento ||
                                //   item.data.nomeSocietaEroganteInServizio ||
                                //   item.data.nomeConduttore ||
                                //   item.data.ragioneSocialeCostruttore ||
                                //   item.data.daNome ||
                                //   item.data.riferimentoComuneASL ||
                                //   item.data.nomeAmministratoreDelCondominio ||
                                //   item.data.nomeIdentificativoDellaReteDiTeleriscaldamento ||
                                //   item.data.aFirmaDi ||
                                //   item.data.nomeFornitore) &&
                                typeof item.data.ragioneSocialeFornitore === "undefined") {
                                if (item.data.rilasciatoFirmatoDa) {
                                    item.data["ragioneSocialeFornitore"] =
                                        item.data.rilasciatoFirmatoDa;
                                }
                                else if (item.data.nomeDiRiferimento) {
                                    item.data["ragioneSocialeFornitore"] =
                                        item.data.nomeDiRiferimento;
                                }
                                else if (item.data.nomeConduttore) {
                                    item.data["ragioneSocialeFornitore"] =
                                        item.data.nomeConduttore;
                                }
                                else if (item.data.ragioneSocialeCostruttore) {
                                    item.data["ragioneSocialeFornitore"] =
                                        item.data.ragioneSocialeCostruttore;
                                }
                                else if (item.data.daNome) {
                                    item.data["ragioneSocialeFornitore"] = item.data.daNome;
                                }
                                else if (item.data.riferimentoComuneASL) {
                                    item.data["ragioneSocialeFornitore"] =
                                        item.data.riferimentoComuneASL;
                                }
                                else if (item.data.nomeAmministratoreDelCondominio) {
                                    item.data["ragioneSocialeFornitore"] =
                                        item.data.nomeAmministratoreDelCondominio;
                                }
                                else if (item.data.nomeIdentificativoDellaReteDiTeleriscaldamento) {
                                    item.data["ragioneSocialeFornitore"] =
                                        item.data.nomeIdentificativoDellaReteDiTeleriscaldamento;
                                }
                                else if (item.data.aFirmaDi) {
                                    item.data["ragioneSocialeFornitore"] = item.data.aFirmaDi;
                                }
                                else if (item.data.nomeFornitore) {
                                    item.data["ragioneSocialeFornitore"] =
                                        item.data.nomeFornitore;
                                }
                                else {
                                    item.data["ragioneSocialeFornitore"] =
                                        item.data.nomeSocietaEroganteInServizio;
                                }
                            }
                            if (item.data && item.data.barCode) {
                                if (item.data.barCode.length > 6) {
                                    item.data["docCode"] = item.data.barCode.substring(item.data.barCode.length - 7, item.data.barCode.length - 1);
                                }
                            }
                            docList.push({
                                title: _this.translateService.instant("properties.documents.titles." + doc),
                                type: "doc",
                                docId: item._id,
                                key: doc,
                                mandatory: (_this.subscriptionType === "FREE" || _this.subscriptionType === "FREEBASIC") ? false : item.mandatory,
                                expired: item.expired,
                                deleted: item.deleted,
                                dateExpired: item.dateExpired,
                                contract: item.contract,
                                pdfmsg: item.pdfmsg,
                                data: item.data,
                                checked: false,
                                keyTranslateTitle: keyTranslateTitle,
                            });
                        }
                        // only contracts
                        var contractSection = doc.substr(0, 2) === "HA" ? true : false;
                        if (!item.deleted && item.data && contractSection) {
                            _this.insertedDocs.push({
                                title: _this.translateService.instant("properties.documents.titles." + doc),
                                docId: item._id,
                                data: item.data,
                                checked: false,
                                keyTranslateTitle: keyTranslateTitle,
                            });
                        }
                    }
                });
            }
        };
        for (var doc in section.documents) {
            _loop_2(doc);
        }
        docList.sort(this.compareExpired);
        return docList;
    };
    /**
     * Order docs by expired property
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.compareExpired = function (a, b) {
        if (a.expired < b.expired) {
            return -1;
        }
        else if (a.expired > b.expired) {
            return 1;
        }
        else {
            return 0;
        }
    };
    /**
     * Count document per area and make visible the area in side menu.
     * Count mandatory, mandatory not inserted and generic document.
     * Show the counters into badge of side menu.
     * method used into getDocumentArchiveData()
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.countDocPerArea = function () {
        var _this = this;
        this.totMandatoryDocs = 0;
        this.totInsertDocs = 0;
        this.totNotInsertDocs = 0;
        this.totOptionalDocs = 0;
        this.totDocs = 0;
        // Only Privacy
        if (this.subscriptionType === 'PRIVACY' &&
            !this.loggedUserAdmin) {
            this.documentsStructure = this.documentsStructure.filter(function (el) { return el.title === "properties.documents.gestionaleAmministrativo"; });
            this.documentsStructure.forEach(function (el) {
                if (Array.isArray(el.content)) {
                    el.content = el.content.filter(function (subEl) {
                        return subEl.title === "properties.documents.Aprivacy" ||
                            subEl.title === "properties.documents.gestAmmTivoDipendenti" ||
                            subEl.title === "properties.documents.gestAmmTivoGestionali";
                    });
                }
            });
        }
        // Hide all visible elements of side menu
        for (var key in this.documentsStructure) {
            this.documentsStructure[key].visible = false;
            if (Array.isArray(this.documentsStructure[key].content)) {
                this.documentsStructure[key].content.forEach(function (el) {
                    el.visible = false;
                });
            }
        }
        if (this.allDocs && Array.isArray(this.allDocs)) {
            this.allDocs.forEach(function (item) {
                var title = item.keyTranslateTitle;
                var levels = item.content;
                if (title !== "properties.documents.unitaImmobiliari" &&
                    title !== "properties.documents.attivitaSottopostePrevenzioneIncendi") {
                    var _loop_3 = function (key) {
                        if (_this.documentsStructure[key].title === title) {
                            _this.documentsStructure[key].visible = true;
                            var allStructuresDeleted_1 = true;
                            if (_this.showStructureDeleted) {
                                allStructuresDeleted_1 = false;
                            }
                            levels.forEach(function (el) {
                                _this.documentsStructure[key].content.forEach(function (subEl) {
                                    if (subEl.title === el.keyTranslateTitle) {
                                        var allSubStructuresDeleted_1 = true;
                                        if (_this.showStructureDeleted) {
                                            allSubStructuresDeleted_1 = false;
                                        }
                                        if (typeof el.active !== "undefined") {
                                            // Only for "Gestione Dipendneti"
                                            if (_this.showStructureDeleted) {
                                                // A deleted section left without rows is pruned from the archive by
                                                // filterDisplayedDocs, so its voice would point at nothing.
                                                subEl.visible = el.active ? true : _this.hasAnyDocument(el);
                                            }
                                            else {
                                                subEl.visible = el.active;
                                            }
                                        }
                                        else {
                                            subEl.visible = true;
                                        }
                                        subEl.notInsert = 0;
                                        subEl.mandatory = 0;
                                        subEl.optional = 0;
                                        if (Array.isArray(el.content)) {
                                            el.content.forEach(function (subSubEl) {
                                                if (!_this.showStructureDeleted &&
                                                    (typeof subSubEl.active === "undefined" ||
                                                        subSubEl.active)) {
                                                    allSubStructuresDeleted_1 = false;
                                                }
                                                if (_this.showStructureDeleted ||
                                                    (!_this.showStructureDeleted &&
                                                        (typeof subSubEl.active === "undefined" ||
                                                            subSubEl.active))) {
                                                    if (Array.isArray(subSubEl.content)) {
                                                        subSubEl.content.forEach(function (subSubSubEl) {
                                                            if (subSubSubEl.mandatory) {
                                                                _this.totMandatoryDocs++;
                                                                if (_this.helperService.isDocumentDataPopulated(subSubSubEl.data)) {
                                                                    subEl.mandatory++;
                                                                    _this.totInsertDocs++;
                                                                }
                                                            }
                                                            if (subSubSubEl.mandatory &&
                                                                !_this.helperService.isDocumentDataPopulated(subSubSubEl.data)) {
                                                                subEl.notInsert++;
                                                                _this.totNotInsertDocs++;
                                                            }
                                                            if (!subSubSubEl.mandatory) {
                                                                subEl.optional++;
                                                                _this.totOptionalDocs++;
                                                            }
                                                        });
                                                    }
                                                    else {
                                                        if (subSubEl.mandatory) {
                                                            _this.totMandatoryDocs++;
                                                            if (_this.helperService.isDocumentDataPopulated(subSubEl.data)) {
                                                                subEl.mandatory++;
                                                                _this.totInsertDocs++;
                                                            }
                                                        }
                                                        if (subSubEl.mandatory &&
                                                            !_this.helperService.isDocumentDataPopulated(subSubEl.data)) {
                                                            subEl.notInsert++;
                                                            _this.totNotInsertDocs++;
                                                        }
                                                        if (!subSubEl.mandatory) {
                                                            subEl.optional++;
                                                            _this.totOptionalDocs++;
                                                        }
                                                    }
                                                }
                                            });
                                        }
                                        if (allSubStructuresDeleted_1) {
                                            subEl.visible = false;
                                        }
                                        else {
                                            allStructuresDeleted_1 = false;
                                        }
                                    }
                                });
                            });
                            if (allStructuresDeleted_1) {
                                _this.documentsStructure[key].visible = false;
                            }
                            return "break";
                        }
                    };
                    for (var key in _this.documentsStructure) {
                        var state_1 = _loop_3(key);
                        if (state_1 === "break")
                            break;
                    }
                }
                else if (title === "properties.documents.unitaImmobiliari") {
                    var _loop_4 = function (key) {
                        if (_this.documentsStructure[key].title === title) {
                            var allStructuresDeleted_2 = true;
                            if (_this.showStructureDeleted) {
                                allStructuresDeleted_2 = false;
                            }
                            _this.documentsStructure[key].content.length = 0;
                            _this.documentsStructure[key].visible = true;
                            levels.forEach(function (el) {
                                var subEl = {
                                    title: el.title,
                                    type: "link",
                                    section: "string",
                                    key: "",
                                    visible: true,
                                    notInsert: 0,
                                    mandatory: 0,
                                    optional: 0,
                                };
                                // With the toggle on, a deleted unit is listed only while it still owns rows:
                                // filterDisplayedDocs prunes the empty ones from the archive, so the voice
                                // would point at a section the page does not render.
                                if ((_this.showStructureDeleted &&
                                    (el.active || _this.hasAnyDocument(el))) ||
                                    (!_this.showStructureDeleted && el.active)) {
                                    allStructuresDeleted_2 = false;
                                    if (Array.isArray(el.content)) {
                                        el.content.forEach(function (subSubEl) {
                                            if (Array.isArray(subSubEl.content)) {
                                                subSubEl.content.forEach(function (subSubSubEl) {
                                                    if (subSubSubEl.mandatory) {
                                                        _this.totMandatoryDocs++;
                                                        if (_this.helperService.isDocumentDataPopulated(subSubSubEl.data)) {
                                                            subEl.mandatory++;
                                                            _this.totInsertDocs++;
                                                        }
                                                    }
                                                    if (subSubSubEl.mandatory &&
                                                        !_this.helperService.isDocumentDataPopulated(subSubSubEl.data)) {
                                                        subEl.notInsert++;
                                                        _this.totNotInsertDocs++;
                                                    }
                                                    if (!subSubSubEl.mandatory) {
                                                        subEl.optional++;
                                                        _this.totOptionalDocs++;
                                                    }
                                                });
                                            }
                                            else {
                                                if (subSubEl.mandatory) {
                                                    _this.totMandatoryDocs++;
                                                    if (_this.helperService.isDocumentDataPopulated(subSubEl.data)) {
                                                        subEl.mandatory++;
                                                        _this.totInsertDocs++;
                                                    }
                                                }
                                                if (subSubEl.mandatory &&
                                                    !_this.helperService.isDocumentDataPopulated(subSubEl.data)) {
                                                    subEl.notInsert++;
                                                    _this.totNotInsertDocs++;
                                                }
                                                if (!subSubEl.mandatory) {
                                                    subEl.optional++;
                                                    _this.totOptionalDocs++;
                                                }
                                            }
                                        });
                                    }
                                    _this.documentsStructure[key].content.push(subEl);
                                }
                            });
                            if (allStructuresDeleted_2) {
                                _this.documentsStructure[key].visible = false;
                            }
                            return "break";
                        }
                    };
                    for (var key in _this.documentsStructure) {
                        var state_2 = _loop_4(key);
                        if (state_2 === "break")
                            break;
                    }
                }
                else if (title === "properties.documents.attivitaSottopostePrevenzioneIncendi") {
                    var _loop_5 = function (key) {
                        if (_this.documentsStructure[key].title === title) {
                            var allStructuresDeleted_3 = true;
                            if (_this.showStructureDeleted) {
                                allStructuresDeleted_3 = false;
                            }
                            _this.documentsStructure[key].content.length = 0;
                            _this.documentsStructure[key].visible = true;
                            if (Array.isArray(levels[0].content)) {
                                levels[0].content.forEach(function (el) {
                                    if (_this.subscriptionType === "FREE" || _this.subscriptionType === "FREEBASIC") {
                                        var subEl = {
                                            title: levels[0].keyTranslateTitle,
                                            translation: _this.documentsStructure[key].translation,
                                            type: "link",
                                            section: "string",
                                            key: "",
                                            visible: true,
                                            notInsert: 0,
                                            mandatory: 0,
                                            optional: 0,
                                        };
                                        allStructuresDeleted_3 = false;
                                        if (el.mandatory) {
                                            _this.totMandatoryDocs++;
                                            if (_this.helperService.isDocumentDataPopulated(el.data)) {
                                                subEl.mandatory++;
                                                _this.totInsertDocs++;
                                            }
                                        }
                                        if (el.mandatory &&
                                            !_this.helperService.isDocumentDataPopulated(el.data)) {
                                            subEl.notInsert++;
                                            _this.totNotInsertDocs++;
                                        }
                                        if (!el.mandatory) {
                                            subEl.optional++;
                                            _this.totOptionalDocs++;
                                        }
                                        _this.documentsStructure[key].content.push(subEl);
                                    }
                                    else {
                                        var subEl_1 = {
                                            title: el.title,
                                            type: "link",
                                            section: "string",
                                            key: "",
                                            visible: true,
                                            notInsert: 0,
                                            mandatory: 0,
                                            optional: 0,
                                        };
                                        // Same rule as the property units above: with the toggle on a deleted
                                        // structure keeps its voice only while it still owns rows. Here the
                                        // archive is even stricter, documentTypes.ts drops the node when the
                                        // section has no documents at all.
                                        if ((_this.showStructureDeleted &&
                                            (el.active || _this.hasAnyDocument(el))) ||
                                            (!_this.showStructureDeleted && el.active)) {
                                            allStructuresDeleted_3 = false;
                                            if (Array.isArray(el.content)) {
                                                el.content.forEach(function (subSubEl) {
                                                    if (Array.isArray(subSubEl.content)) {
                                                        subSubEl.content.forEach(function (subSubSubEl) {
                                                            if (subSubSubEl.mandatory) {
                                                                _this.totMandatoryDocs++;
                                                                if (_this.helperService.isDocumentDataPopulated(subSubSubEl.data)) {
                                                                    subEl_1.mandatory++;
                                                                    _this.totInsertDocs++;
                                                                }
                                                            }
                                                            if (subSubSubEl.mandatory &&
                                                                !_this.helperService.isDocumentDataPopulated(subSubSubEl.data)) {
                                                                subEl_1.notInsert++;
                                                                _this.totNotInsertDocs++;
                                                            }
                                                            if (!subSubSubEl.mandatory) {
                                                                subEl_1.optional++;
                                                                _this.totOptionalDocs++;
                                                            }
                                                        });
                                                    }
                                                    else {
                                                        if (subSubEl.mandatory) {
                                                            _this.totMandatoryDocs++;
                                                            if (_this.helperService.isDocumentDataPopulated(subSubEl.data)) {
                                                                subEl_1.mandatory++;
                                                                _this.totInsertDocs++;
                                                            }
                                                        }
                                                        if (subSubEl.mandatory &&
                                                            !_this.helperService.isDocumentDataPopulated(subSubEl.data)) {
                                                            subEl_1.notInsert++;
                                                            _this.totNotInsertDocs++;
                                                        }
                                                        if (!subSubEl.mandatory) {
                                                            subEl_1.optional++;
                                                            _this.totOptionalDocs++;
                                                        }
                                                    }
                                                });
                                            }
                                            _this.documentsStructure[key].content.push(subEl_1);
                                        }
                                    }
                                });
                            }
                            if (allStructuresDeleted_3) {
                                _this.documentsStructure[key].visible = false;
                            }
                            return "break";
                        }
                    };
                    for (var key in _this.documentsStructure) {
                        var state_3 = _loop_5(key);
                        if (state_3 === "break")
                            break;
                    }
                }
            });
        }
        this.progressBarVal = 0;
        if (this.totInsertDocs + this.totNotInsertDocs > 0) {
            this.progressBarVal = Math.trunc((this.totInsertDocs / (this.totInsertDocs + this.totNotInsertDocs)) *
                100);
        }
        this.progressBarValStyle = { width: this.progressBarVal + "%" };
        // Only Privacy
        if (this.subscriptionType === 'PRIVACY' &&
            !this.loggedUserAdmin) {
            this.totDocs = this.totInsertDocs + this.totOptionalDocs;
        }
        else {
            // this.totDocs = this.totOptionalDocs + this.totInsertDocs;
            this.totDocs = this.property.get("totalDocsInserted");
            this.subscriptions.push(this.propertiesService.get(this.propertyId).subscribe(function (res) {
                if (res.status) {
                    _this.property.setData(res.data);
                    _this.totDocs = res.data.totalDocsInserted;
                    return;
                }
            }, function (err) {
                // if we came here users with given userId do not exist
            }));
        }
        if (this.loggedUserShared || this.loggedUserTemporary) {
            for (var key in this.documentsStructure) {
                switch (this.documentsStructure[key].title) {
                    case "properties.documents.gestionaleAmministrativo":
                        if (!this.currentRole.propertiesPermission.gestionaleAmministrativo) {
                            this.documentsStructure[key].visible = false;
                        }
                        break;
                    case "properties.documents.verbaliconvocazioni":
                        if (!this.currentRole.propertiesPermission.gestionaleContabile) {
                            this.documentsStructure[key].visible = false;
                        }
                        break;
                    case "properties.documents.urbanisticaEdEdilizia":
                        if (!this.currentRole.propertiesPermission.urbanisticaEdEdilizia) {
                            this.documentsStructure[key].visible = false;
                        }
                        break;
                    case "properties.documents.catasto":
                        if (!this.currentRole.propertiesPermission.catasto) {
                            this.documentsStructure[key].visible = false;
                        }
                        break;
                    case "properties.documents.locazioneContrdiLocazione":
                        if (!this.currentRole.propertiesPermission.contratti) {
                            this.documentsStructure[key].visible = false;
                        }
                        break;
                    case "properties.documents.contratti":
                        if (!this.currentRole.propertiesPermission.contratti) {
                            this.documentsStructure[key].visible = false;
                        }
                        break;
                    case "properties.documents.lineaVita":
                        if (!this.currentRole.propertiesPermission.lineaVita) {
                            this.documentsStructure[key].visible = false;
                        }
                        break;
                    case "properties.documents.amiantoDoc":
                        if (!this.currentRole.propertiesPermission.amiantoDoc) {
                            this.documentsStructure[key].visible = false;
                        }
                        break;
                    case "properties.documents.edile":
                        if (!this.currentRole.propertiesPermission.edile) {
                            this.documentsStructure[key].visible = false;
                        }
                        break;
                    case "properties.documents.impiantoElettrico":
                        if (!this.currentRole.propertiesPermission.impiantoElettrico) {
                            this.documentsStructure[key].visible = false;
                        }
                        break;
                    case "properties.documents.riscaldamentoCondizionamento":
                        if (!this.currentRole.propertiesPermission.riscaldamentoCondizionamento) {
                            this.documentsStructure[key].visible = false;
                        }
                        break;
                    case "properties.documents.ascensoriEMontauto":
                        if (!this.currentRole.propertiesPermission.ascensori) {
                            this.documentsStructure[key].visible = false;
                        }
                        break;
                    case "properties.documents.trattamentoAcqua":
                        if (!this.currentRole.propertiesPermission.trattamentoAcqua) {
                            this.documentsStructure[key].visible = false;
                        }
                        break;
                    case "properties.documents.impiantiElettronici":
                        if (!this.currentRole.propertiesPermission.impiantiElettronici) {
                            this.documentsStructure[key].visible = false;
                        }
                        break;
                    case "properties.documents.attivitaSottopostePrevenzioneIncendi":
                        if (!this.currentRole.propertiesPermission.antincendio) {
                            this.documentsStructure[key].visible = false;
                        }
                        break;
                    case "properties.documents.impiantiAntincendio":
                        if (!this.currentRole.propertiesPermission.antincendio) {
                            this.documentsStructure[key].visible = false;
                        }
                        break;
                    case "properties.documents.impiantiSpeciali":
                        if (!this.currentRole.propertiesPermission.impiantiSpeciali) {
                            this.documentsStructure[key].visible = false;
                        }
                        break;
                    case "properties.documents.impiantiRicreativiSportivi":
                        if (!this.currentRole.propertiesPermission.impiantiRicreativiSportivi) {
                            this.documentsStructure[key].visible = false;
                        }
                        break;
                    case "properties.documents.manutenzioni":
                        if (!this.currentRole.propertiesPermission.preventivi) {
                            this.documentsStructure[key].visible = false;
                        }
                        break;
                    case "properties.documents.unitaImmobiliari":
                        if (!this.currentRole.propertiesPermission.unitaImmobiliari) {
                            this.documentsStructure[key].visible = false;
                        }
                        break;
                }
            }
        }
    };
    /**
     * Handle insert doc dialog component
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.onInsertDocDialogOpen = function (docItem) {
        var _this = this;
        var barCode = "";
        if (docItem && docItem.barCode) {
            barCode = docItem.barCode;
        }
        else {
            var total = (+this.property.get("totalDocsProgressive") + 1).toString();
            barCode = this.property.getId() + "S" + total.padStart(6, "0") + "C";
        }
        // const selectedArea = this.documentTypeStructure.getAreaFromChild(
        //   docItem.keyTranslateTitle
        // );
        var selectedArea = this.documentTypeStructure.getAreaFromChild2(docItem.keyTranslateTitle, this.documentTemplate);
        var dialogRef = this.dialog.open(PropertyDetailDocumentInsertDialogComponent, {
            data: {
                modalTitle: this.translateService.instant("properties.addDocumentsPage.documentsTab.title"),
                documentArchive: this.documentArchive,
                documentArchiveId: this.documentArchiveId,
                condoStructure: this.condoStructure,
                subscriptionType: this.subscriptionType,
                key: docItem.keyTranslateTitle.split("properties.documents.")[1],
                barCode: barCode,
                selectedArea: selectedArea,
                propertyId: this.propertyId,
                property: this.property,
            },
            width: "70vw",
            minHeight: "500px",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            else {
                // recreate view of all docs to show new inserted doc
                _this.allDocs = [];
                if (_this.subscriptionType === "FREE" || _this.subscriptionType === "FREEBASIC") {
                    _this.getDocumentArchiveDataFree();
                }
                else {
                    _this.getDocumentArchiveData();
                }
            }
        }, function (err) {
            _this.helperService.handleError(err);
        });
    };
    /**
     * Handle click on document and open dialog box to edit/show document data
     *
     * modalTitle: title of dialogbox from document name
     * documentKey: doc type, es. AA1, AA2, etc.
     * documentId: the ID of document into array of documentArchive section (es. gestAmmTivoDipendenti)
     * subDocumentId: the ID of sub document into array of docs type (es. AA1)
     * itemData: data value of form items
     * action: edit or show doc data
     * documentFather:
     * keyTranslateTitle:
     * structureId: related structure Id
     * expired:
     * contractPdfMsg:
     * sameCodeTargets: "edit" only. Left out by the template, which makes the method first offer the
     *   other rows with the same code (see selectSameCodeDocsToEdit); null edits the clicked row alone;
     *   a list saves the form on each of those rows.
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.onToggleEditShowDocument = function (modalTitle, documentKey, documentId, subDocumentId, itemData, action, documentFather, keyTranslateTitle, structureId, expired, contractPdfMsg, topic, sameCodeTargets) {
        var e_1, _a;
        var _this = this;
        // if (this.subscriptionType === "FREE") {
        //   documentId = "undefined";
        // }
        // Create formly default fields
        var defaultFields = [
            {
                className: "col-12 col-md-12 col-xl-12",
                type: "textarea",
                key: "contenutoDocumento",
                templateOptions: {
                    label: this.translateService.instant("properties.detail.documentArchive.fields.contenutoDocumento"),
                    placeholder: this.translateService.instant("properties.detail.documentArchive.fields.contenutoDocumento"),
                    required: true,
                    minLength: 2,
                    maxLength: 500,
                    rows: 5,
                    disabled: action === "show" ? true : false,
                },
            },
            {
                className: "col-12 col-md-12 col-xl-12",
                type: "input",
                key: "protocollo",
                templateOptions: {
                    readonly: false,
                    label: this.translateService.instant("properties.detail.documentArchive.fields.protocollo"),
                    placeholder: this.translateService.instant("properties.detail.documentArchive.fields.protocollo"),
                    required: false,
                    minLength: 0,
                    maxLength: 500,
                },
            },
            {
                className: "col-12 col-md-12 col-xl-12",
                type: "textarea",
                key: "keyword",
                templateOptions: {
                    readonly: false,
                    label: this.translateService.instant("properties.detail.documentArchive.fields.keyword"),
                    placeholder: this.translateService.instant("properties.detail.documentArchive.fields.keyword"),
                    required: false,
                    minLength: 0,
                    maxLength: 1000,
                    rows: 3
                },
            }
        ];
        // create fields formly from document key: es AA1
        // const aryfields = this.documentTypeStructure.getFormlyFields(
        //   documentKey,
        //   false
        // );
        var schemaType = JSON.parse(JSON.stringify(this.documentTypeStructure.getDocumentType2(documentKey, this.documentTemplate)));
        var aryfields = this.documentTypeStructure.getFormlyFields2(schemaType, false);
        aryfields.forEach(function (item) {
            if (item.templateOptions && item.templateOptions.placeholder) {
                item.templateOptions.placeholder = _this.translateService.instant(item.templateOptions.placeholder);
            }
            if (item.type === "select") {
                if (Array.isArray(item.templateOptions.options)) {
                    item.templateOptions.options.forEach(function (subItem) {
                        subItem.label = _this.translateService.instant(subItem.label);
                    });
                }
            }
            if (item.type === "selectNew") {
                item.type = "autocomplete";
                if (item.templateOptions.initialValues) {
                    var options_1 = [];
                    switch (item.templateOptions.initialValues) {
                        case "suppliersName":
                            _this.suppliersName.forEach(function (subItem) {
                                // options.push({
                                //   value: subItem,
                                //   label: subItem,
                                // });
                                options_1.push(subItem);
                            });
                            break;
                        case "yearsOfStorage":
                            _this.yearsOfStorage.forEach(function (subItem) {
                                // options.push({
                                //   value: subItem,
                                //   label: subItem,
                                // });
                                options_1.push(subItem);
                            });
                            break;
                        case "conductorName":
                            _this.conductorName.forEach(function (subItem) {
                                // options.push({
                                //   value: subItem,
                                //   label: subItem,
                                // });
                                options_1.push(subItem);
                            });
                            break;
                        case "nameInterventionArchiving":
                            _this.nameInterventionArchiving.forEach(function (subItem) {
                                // options.push({
                                //   value: subItem,
                                //   label: subItem,
                                // });
                                options_1.push(subItem);
                            });
                            break;
                    }
                    item.templateOptions.initialValues = options_1;
                    item.templateOptions.addTagText = _this.translateService.instant(item.templateOptions.addTagText);
                    item.templateOptions.customLabel = _this.translateService.instant(item.templateOptions.customLabel);
                }
            }
            if (item.type === "autocomplete" ||
                item.type === "autocomplete-supplier") {
                item.templateOptions.addTagText = _this.translateService.instant(item.templateOptions.addTagText);
                item.templateOptions.customLabel = _this.translateService.instant(item.templateOptions.customLabel);
                if (item.templateOptions.search$ === "suppliersService") {
                    item.templateOptions.search$ =
                        _this.suppliersService.getListV2.bind(_this);
                }
            }
            else {
                if (item.templateOptions && item.templateOptions.label) {
                    item.templateOptions.label = _this.translateService.instant(item.templateOptions.label);
                }
            }
            if (action === "show" && item.templateOptions) {
                item.templateOptions.disabled = true;
            }
        });
        // const contract = this.documentTypeStructure.isContract(documentKey);
        var contract = this.documentTypeStructure.isContract2(documentKey, this.documentTemplate);
        var fieldGroup = aryfields.concat(defaultFields);
        var itemConfig = [
            {
                fieldGroupClassName: "row",
                fieldGroup: fieldGroup,
            },
        ];
        var propertyCode = this.propertyData.code;
        var companyCode = this.company.get("code");
        var barCode = "";
        if (itemData && itemData.barCode) {
            barCode = itemData.barCode;
        }
        else {
            // just for Paper doc
            var total = (+this.property.get("totalDocsProgressive") + 1).toString();
            barCode = this.property.getId() + "S" + total.padStart(6, "0") + "C";
        }
        // const selectedArea =
        //   this.documentTypeStructure.getAreaFromChild(keyTranslateTitle);
        var selectedArea = this.documentTypeStructure.getAreaFromChild2(keyTranslateTitle, this.documentTemplate);
        var title;
        if (keyTranslateTitle) {
            title = keyTranslateTitle.split("properties.documents.")[1];
        }
        if (this.subscriptionType !== "FREE" && this.subscriptionType !== "FREEBASIC") {
            var _loop_6 = function (docs) {
                if (!docs.deleted) {
                    var content = docs.content;
                    if (content && Array.isArray(content)) {
                        var index = content.findIndex(function (subDocs) {
                            return (subDocs.title.replace("properties.documents.", "") === title);
                        });
                        if (index > -1) {
                            var structure_1 = content[index].structure;
                            if (structure_1 && structure_1 !== "") {
                                this_1.condoStructure[structure_1].forEach(function (item) {
                                    if (typeof item.active !== "undefined" &&
                                        item.active) {
                                        var ids = _this.structureSelected.map(function (el) { return el.id; });
                                        var name_1 = item.nome;
                                        switch (structure_1) {
                                            case "dipendenti":
                                                name_1 = item.nome + " " + item.cognome;
                                                break;
                                            case "contatoreGas":
                                                name_1 = item.nome + " - " + item.codicePdr;
                                                break;
                                            case "ascensore":
                                                name_1 = item.nome + " - " + item.numeroMatricola;
                                                break;
                                            case "montauto":
                                                name_1 = item.nome + " - " + item.numeroMatricola;
                                                break;
                                            case "contatoriAcqua":
                                                name_1 = item.nome + " - " + item.codiceUtente;
                                                break;
                                            // case "estintori":
                                            //   name = "Estintori";
                                            //   break;
                                        }
                                        var selStructure_1 = {
                                            id: item._id,
                                            name: name_1,
                                            value: false,
                                            type: structure_1,
                                        };
                                        // Prevent duplicate insert
                                        if (ids.includes(selStructure_1.id)) {
                                            itemData = tslib_1.__assign({}, itemData, { structureSelected: _this.structureSelected.filter(function (el) { return el.type === selStructure_1.type; }) });
                                            return;
                                        }
                                        _this.structureSelected.push(selStructure_1);
                                        itemData = tslib_1.__assign({}, itemData, { structureSelected: _this.structureSelected.filter(function (el) { return el.type === selStructure_1.type; }) });
                                    }
                                });
                            }
                            else {
                                // vvFdefinitivo
                                if (title === "vvFdefinitivo") {
                                    if (this_1.documentArchive.vvFdefinitivo &&
                                        Array.isArray(this_1.documentArchive.vvFdefinitivo)) {
                                        this_1.documentArchive.vvFdefinitivo.forEach(function (item) {
                                            if (item.structureObjectType !== "") {
                                                var ids = _this.structureSelected.map(function (el) { return el.id; });
                                                var structure_2 = {
                                                    id: item.structureObjectId,
                                                    name: item.structureObjectName,
                                                    value: false,
                                                    type: "vvFdefinitivo",
                                                    typeStructure: item.structureObjectType,
                                                };
                                                // Prevent duplicate insert
                                                if (ids.includes(structure_2.id)) {
                                                    itemData = tslib_1.__assign({}, itemData, { structureSelected: _this.structureSelected.filter(function (el) { return el.type === structure_2.type; }) });
                                                    return;
                                                }
                                                _this.structureSelected.push(structure_2);
                                                itemData = tslib_1.__assign({}, itemData, { structureSelected: _this.structureSelected.filter(function (el) { return el.type === structure_2.type; }) });
                                            }
                                        });
                                    }
                                }
                                else if (title === "contratti" && documentKey === "HA12") {
                                    this_1.condoStructure['fornituraBt'].forEach(function (item) {
                                        if (typeof item.active !== "undefined" &&
                                            item.active &&
                                            item._id.toString() === structureId.toString()) {
                                            var ids = _this.structureSelected.map(function (el) { return el.id; });
                                            var selStructure_2 = {
                                                id: item._id,
                                                name: 'fornituraBt',
                                                value: true,
                                                type: 'fornituraBt',
                                            };
                                            // Prevent duplicate insert
                                            if (ids.includes(selStructure_2.id)) {
                                                itemData = tslib_1.__assign({}, itemData, { structureSelected: _this.structureSelected.filter(function (el) { return el.type === selStructure_2.type; }) });
                                                return;
                                            }
                                            _this.structureSelected.push(selStructure_2);
                                            itemData = tslib_1.__assign({}, itemData, { structureSelected: _this.structureSelected.filter(function (el) { return el.type === selStructure_2.type; }) });
                                        }
                                    });
                                }
                                else if (title === "contratti" && documentKey === "HA64") {
                                    this_1.condoStructure['fornituraMt'].forEach(function (item) {
                                        if (typeof item.active !== "undefined" &&
                                            item.active &&
                                            item._id.toString() === structureId.toString()) {
                                            var ids = _this.structureSelected.map(function (el) { return el.id; });
                                            var selStructure_3 = {
                                                id: item._id,
                                                name: 'fornituraMt',
                                                value: true,
                                                type: 'fornituraMt',
                                            };
                                            // Prevent duplicate insert
                                            if (ids.includes(selStructure_3.id)) {
                                                itemData = tslib_1.__assign({}, itemData, { structureSelected: _this.structureSelected.filter(function (el) { return el.type === selStructure_3.type; }) });
                                                return;
                                            }
                                            _this.structureSelected.push(selStructure_3);
                                            itemData = tslib_1.__assign({}, itemData, { structureSelected: _this.structureSelected.filter(function (el) { return el.type === selStructure_3.type; }) });
                                        }
                                    });
                                }
                            }
                            return "break";
                        }
                    }
                }
            };
            var this_1 = this;
            try {
                //edilecanneFumarieColl
                for (var _b = tslib_1.__values(this.documentTemplate), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var docs = _c.value;
                    var state_4 = _loop_6(docs);
                    if (state_4 === "break")
                        break;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        else {
            switch (title) {
                case "contratti":
                    // this.contratti = true;
                    itemData = tslib_1.__assign({}, itemData, { structureSelected: "-1" });
                    break;
                case "gestAmmTivoDipendenti":
                case "lineaVita":
                case "impeleGruppoElettrogeno":
                case "impeleFotovoltaico":
                case "impelescaricheAtmosferiche":
                case "riscaldrisccentraliz":
                case "serbatoioAGasolio":
                case "riscaldgasMetcontatrete":
                case "riscaldsottostazriscaldamen":
                case "riscaldcanneFumariePerCt":
                case "riscaldsolareTermico":
                case "riscaldcentrteleriscaldamen":
                case "riscGeotermicoPozzi":
                case "riscGeotermicoSonde":
                case "riscaldsoloPompeDiCalore":
                case "riscaldcentrRicevBsc":
                case "riscaldimpcondizionamento":
                case "ascensoriEMontautoAscensori":
                case "ascensoriEMontautoMontauto":
                case "tratAcquaContatoreAcqua":
                case "tratAcquaCentraleIdrica":
                case "tratAcquaSottAlimDaBsc":
                case "tratAcquaPompSollacqpiov":
                case "impElettronicitvTerrestre":
                case "impElettronicitvSatellitare":
                case "impElettroniciautomazioni":
                case "impElettroniciimpCitofonico":
                case "impElettroniciimpiantoTvcc":
                case "impElettroniciantintrusione":
                case "vvFdefinitivo":
                case "incendioEstintori":
                case "incendioReteIdranti":
                case "incendioReteSprinkler":
                case "incendioStazionePompaggio":
                case "incendioRilevazione":
                case "incendioVentilazione":
                case "impiantiSpeciali":
                case "impricreativipiscina":
                case "impricreativipalestra":
                case "impricreativicampoTennis":
                case "impricreativicampoCalcio":
                case "impricreativiparcoGiochi":
                case "unitaimmvvf":
                case "unitaImmdocAmm":
                case "unitaimmelettrico":
                case "unitaimmantintrusione":
                case "unitaimmidricoSanitari":
                case "unitaimmtermico":
                case "unitaimmcondizionamento":
                case "unitaimmape":
                case "unitaimmelaboratiGrafici":
                case "unitaimmcanneFumariePer":
                case "unitaImmsicurezza":
                    itemData = tslib_1.__assign({}, itemData, { structureSelected: "-1" });
                    break;
                default:
                    itemData = tslib_1.__assign({}, itemData, { structureSelected: "" });
            }
            structureId = undefined;
        }
        // "Modifica dati aggiuntivi" on a code that other rows share: offer them before the form opens.
        // The choice comes back into this method with the rows to save, so the form is built as usual.
        if (action === "edit" && typeof sameCodeTargets === "undefined") {
            this.selectSameCodeDocsToEdit(subDocumentId, documentKey, itemData, fieldGroup, structureId !== "" ? structureId : undefined, function (targets) {
                return _this.onToggleEditShowDocument(modalTitle, documentKey, documentId, subDocumentId, itemData, action, documentFather, keyTranslateTitle, structureId, expired, contractPdfMsg, topic, targets);
            });
            return;
        }
        // this.structureSelected = this.structureSelected.find(el => el.id === structureId);
        var dialogRef;
        // Admins can choose between paper or digital document insertion
        if (action === "new" &&
            (this.loggedUserRole.type === "admin" ||
                this.loggedUserRole.type === "operator")) {
            dialogRef = this.dialog.open(DocumentPaperInsertDialogComponent, {
                data: {
                    modalTitle: modalTitle,
                    documentArchiveId: this.documentArchiveId,
                    documentTypeRoute: this.documentTypeStructure.getDocRoute2(documentKey, this.documentTemplate),
                    documentId: documentId,
                    documentKey: documentKey,
                    subDocumentId: subDocumentId,
                    itemData: itemData,
                    itemConfig: itemConfig,
                    propertyCode: propertyCode,
                    companyCode: companyCode,
                    barCode: barCode,
                    action: action,
                    documentFather: documentFather,
                    keyTranslateTitle: title,
                    structureId: structureId,
                    contract: contract,
                    expired: expired,
                    contractPdfMsg: contractPdfMsg,
                    selectedArea: selectedArea,
                    property: this.propertyData,
                    topic: topic,
                },
                width: "700px",
            });
        }
        else {
            dialogRef = this.dialog.open(PropertyDetailDocumentItemDialogComponent, {
                data: {
                    modalTitle: modalTitle,
                    documentArchiveId: this.documentArchiveId,
                    documentTypeRoute: this.documentTypeStructure.getDocRoute2(documentKey, this.documentTemplate),
                    documentId: documentId,
                    documentKey: documentKey,
                    subDocumentId: subDocumentId,
                    itemData: itemData,
                    itemConfig: itemConfig,
                    propertyCode: propertyCode,
                    companyCode: companyCode,
                    barCode: barCode,
                    action: action,
                    documentFather: documentFather,
                    keyTranslateTitle: title,
                    structureId: structureId !== '' ? structureId : undefined,
                    contract: contract,
                    expired: expired,
                    contractPdfMsg: contractPdfMsg,
                    selectedArea: selectedArea,
                    property: this.propertyData,
                    companyData: this.loggedUserMaster ? this.companyData : "",
                    propertyName: this.propertyName,
                    sameCodeTargets: sameCodeTargets || undefined,
                },
                width: "700px",
            });
        }
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                // return;
            }
            else {
                // recreate view of all docs to show new inserted doc
                _this.allDocs = [];
                if (_this.subscriptionType === "FREE" || _this.subscriptionType === "FREEBASIC") {
                    _this.getDocumentArchiveDataFree();
                }
                else {
                    _this.getDocumentArchiveData();
                }
            }
        }, function (err) {
            _this.helperService.handleError(err);
        });
    };
    /**
     * "Modifica dati aggiuntivi" on a document whose code (barcode) other rows share: let the user
     * tick which of those rows receive the edit before the form opens.
     *
     * Every row with that code keeps its own copy of the additional data, and the form shows the data
     * of the clicked row. A row whose data differ, or whose type has other fields, cannot be ticked:
     * saving the form on it would overwrite data the user never saw. Nothing is ticked on opening.
     *
     * `proceed` gets the rows to save, or null to edit the clicked row alone as before: no code, no
     * other row with it, only the clicked row ticked, or a failed lookup. It is not called when the
     * user closes the selection, nor for a second click while the lookup runs.
     *
     * @param subDocumentId `_id` of the clicked row on the page (`subDocId` of its flat row)
     * @param documentKey type of the clicked row, e.g. AA1
     * @param itemData additional data of the clicked row
     * @param formFields fields of the edit form, labels already translated
     * @param clickedStructureId structure segment the single edit of the clicked row sends
     * @param proceed continues the edit with the chosen rows
     *
     * @since 3.0.0
     */
    PropertyDocumentsComponent.prototype.selectSameCodeDocsToEdit = function (subDocumentId, documentKey, itemData, formFields, clickedStructureId, proceed) {
        var _this = this;
        if (this.sameCodeLookupInProgress) {
            return;
        }
        var barCode = itemData && typeof itemData.barCode === "string" ? itemData.barCode.trim() : "";
        if (barCode === "" || !this.documentArchiveId) {
            proceed(null);
            return;
        }
        this.sameCodeLookupInProgress = true;
        this.subscriptions.push(this.documentArchivesService
            // The code is a path segment: a free paper prefix must not be able to change the route
            .getDocsByBarcode(this.documentArchiveId, encodeURIComponent(barCode))
            .pipe(finalize(function () { return (_this.sameCodeLookupInProgress = false); }))
            .subscribe(function (res) {
            if (!res || !res.status) {
                _this.onSameCodeLookupFailed(proceed);
                return;
            }
            var choices = buildSameCodeChoices({
                rows: res.data,
                barCode: barCode,
                clickedSubDocId: subDocumentId,
                clickedKey: documentKey,
                fields: collectSameCodeFormFields(formFields),
                formOf: function (key) { return ({
                    schemaType: _this.documentTypeStructure.getDocumentType2(key, _this.documentTemplate),
                    route: _this.documentTypeStructure.getDocRoute2(key, _this.documentTemplate),
                }); },
            });
            if (!choices || choices.length < 2) {
                proceed(null);
                return;
            }
            var dialogData = { barCode: barCode, choices: choices };
            _this.dialog
                .open(PropertySameCodeEditDialogComponent, { data: dialogData, width: "700px" })
                .beforeClosed()
                .pipe(take(1))
                .subscribe(function (result) {
                var selected = result && Array.isArray(result.selected) ? result.selected : [];
                if (!selected.length) {
                    return;
                }
                if (selected.length === 1 && selected[0].isClicked) {
                    // The clicked row alone: exactly the edit of a single document
                    proceed(null);
                    return;
                }
                proceed(buildSameCodeEditTargets(selected, {
                    clickedStructureId: clickedStructureId,
                    sendStructureIds: _this.subscriptionType !== "FREE" && _this.subscriptionType !== "FREEBASIC",
                    routeOf: function (key) {
                        return _this.documentTypeStructure.getDocRoute2(key, _this.documentTemplate);
                    },
                }));
            });
        }, 
        // The service has already shown the error
        function () { return _this.onSameCodeLookupFailed(proceed); }));
    };
    /**
     * The rows sharing the code could not be read: say so, then edit the clicked row alone
     *
     * @since 3.0.0
     */
    PropertyDocumentsComponent.prototype.onSameCodeLookupFailed = function (proceed) {
        this.toastrService.warning(this.translateService.instant("properties.dialog.docEditSameCodeLookupFailed"));
        proceed(null);
    };
    /**
     * Handle click on document form to download file
     * itemData: data value of form items
     * row: table row the files belong to; its ids let the dialog offer "Scarica tutti" (one zip)
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.onToggleDownloadDocument = function (documents, row) {
        var _this = this;
        if (!documents || !documents.length) {
            console.warn("ERROR: NO DOCS");
            return;
        }
        var dialogRef = this.dialog.open(DocumentDownloadDialogComponent, {
            data: {
                propertyId: this.propertyId,
                documents: documents,
                // `docId` of a row is the `_id` GET document-archives/:id returns for it: the zip endpoint expects it
                documentArchiveId: this.documentArchiveId,
                docId: row && row.docId ? row.docId : "",
                barCode: row && row.data && row.data.barCode ? row.data.barCode : "",
            },
            width: "600px",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            else {
                // recreate view of all docs to show new inserted doc
                _this.allDocs = [];
                if (_this.subscriptionType === "FREE" || _this.subscriptionType === "FREEBASIC") {
                    _this.getDocumentArchiveDataFree();
                }
                else {
                    _this.getDocumentArchiveData();
                }
            }
        });
    };
    /**
     * Handle click on document form to delete file
     * itemData: data value of the document
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.onToggleDeleteDocument = function (item) {
        var _this = this;
        var dialogRef = this.dialog.open(PropertyDeleteDocumentItemDialogComponent, {
            data: {
                documentArchiveId: this.documentArchiveId,
                barCode: item.data.barCode ? item.data.barCode : '',
                mockup: item.mockup ? item.mockup : false,
                item: item,
            },
            width: "600px",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            else {
                // recreate view of all docs to show new inserted doc
                _this.allDocs = [];
                if (_this.subscriptionType === "FREE" || _this.subscriptionType === "FREEBASIC") {
                    _this.getDocumentArchiveDataFree();
                }
                else {
                    _this.getDocumentArchiveData();
                }
            }
        }, function (err) {
            _this.helperService.handleError(err);
        });
    };
    /**
     * Show QRcode section
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.onTogglePrintSectionQRcode = function (item, docItem, subDocItem) {
        var name = this.propertyData.name;
        var city = this.propertyData.address.city;
        var address = this.propertyData.address.route + " " + this.propertyData.address.streetNumber;
        var structureId = "";
        if (subDocItem && subDocItem.structureId && subDocItem.structureId !== "") {
            structureId = subDocItem.structureId;
        }
        var selectedArea;
        if (item &&
            item.content &&
            Array.isArray(item.content) &&
            item.content.length) {
            if (item.content[0].keyTranslateTitle) {
                // const areaNumber = this.documentTypeStructure.getAreaFromChild(
                //   item.content[0].keyTranslateTitle
                // );
                var areaNumber = this.documentTypeStructure.getAreaFromChild2(item.content[0].keyTranslateTitle, this.documentTemplate);
                selectedArea = this.documentTypeStructure.getDocumentArea2(areaNumber.toString(), this.documentTemplate);
            }
        }
        var subStructureRoute = "";
        var subStructure = "";
        if (docItem) {
            subStructureRoute = docItem.keyTranslateTitle.replace("properties.documents.", "");
            subStructure = docItem.title;
        }
        var documentTypeRoute = item.keyTranslateTitle.replace("properties.documents.", "");
        this.dialog.open(PropertyDetailDocumentItemPrintDialogComponent, {
            data: {
                modalTitle: item.title,
                documentArchiveId: this.documentArchiveId,
                documentTypeRoute: documentTypeRoute,
                documentId: "",
                documentKey: "",
                subDocumentId: "",
                itemData: "",
                propertyCode: "",
                companyCode: "",
                barCode: "",
                name: name,
                city: city,
                address: address,
                area: "",
                topic: "",
                structure: "",
                subArea: selectedArea && selectedArea.title ? selectedArea.title : "",
                subStructureRoute: subStructureRoute,
                subStructure: subStructure,
                structureId: structureId,
            },
            width: "700px",
        });
    };
    /**
     * Handle click on document form to print file
     * area: document area
     * topic: document topic
     * type: document type
     * modalTitle: title of dialogbox from document name
     * documentKey: doc type, es. AA1, AA2, etc.
     * documentId: the ID of document into array of documentArchive section (es. gestAmmTivoDipendenti)
     * subDocumentId: the ID of sub document into array of docs type (es. AA1)
     * itemData: data value of form items
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.onTogglePrintDocument = function (subArea, area, topic, structure, modalTitle, documentKey, documentId, subDocumentId, itemData) {
        // key | docId | subDocId
        var propertyCode = this.propertyData.code;
        var companyCode = this.company.get("code");
        // const areaNumber = this.documentTypeStructure.getAreaFromChild(subArea);
        var areaNumber = this.documentTypeStructure.getAreaFromChild2(subArea, this.documentTemplate);
        var selectedArea = this.documentTypeStructure.getDocumentArea2(areaNumber.toString(), this.documentTemplate);
        var barCode = "";
        if (itemData && itemData.barCode) {
            barCode = itemData.barCode;
        }
        var name = this.propertyData.name;
        var city = this.propertyData.address.city;
        var address = this.propertyData.address.route + " " + this.propertyData.address.streetNumber;
        this.dialog.open(PropertyDetailDocumentItemPrintDialogComponent, {
            data: {
                modalTitle: modalTitle,
                documentArchiveId: this.documentArchiveId,
                documentTypeRoute: this.documentTypeStructure.getDocRoute2(documentKey, this.documentTemplate),
                documentId: documentId,
                documentKey: documentKey,
                subDocumentId: subDocumentId,
                itemData: itemData,
                propertyCode: propertyCode,
                companyCode: companyCode,
                barCode: barCode,
                name: name,
                city: city,
                address: address,
                area: area,
                topic: topic,
                structure: structure,
                subArea: selectedArea && selectedArea.title ? selectedArea.title : "",
            },
            width: "700px",
        });
    };
    /**
     * Handle click on document form to print nodule
     * area: document area
     * topic: document topic
     * type: document type
     * modalTitle: title of dialogbox from document name
     * documentKey: doc type, es. AA1, AA2, etc.
     * documentId: the ID of document into array of documentArchive section (es. gestAmmTivoDipendenti)
     * subDocumentId: the ID of sub document into array of docs type (es. AA1)
     * itemData: data value of form items
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.onTogglePrintModuleDoc = function (subArea, structure, modalTitle, itemData) {
        var e_2, _a, e_3, _b;
        // const areaNumber = this.documentTypeStructure.getAreaFromChild(subArea);
        var areaNumber = this.documentTypeStructure.getAreaFromChild2(subArea, this.documentTemplate);
        var selectedArea = this.documentTypeStructure.getDocumentArea2(areaNumber.toString(), this.documentTemplate);
        subArea = subArea.replace("properties.documents.", "");
        var subAreaTitle = "";
        if (selectedArea && selectedArea.content && Array.isArray(selectedArea.content)) {
            try {
                for (var _c = tslib_1.__values(selectedArea.content), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var el = _d.value;
                    if (el.content && Array.isArray(el.content)) {
                        try {
                            for (var _e = (e_3 = void 0, tslib_1.__values(el.content)), _f = _e.next(); !_f.done; _f = _e.next()) {
                                var subEl = _f.value;
                                if (subEl.title && subEl.title.replace("properties.documents.", "") === subArea) {
                                    subAreaTitle = subEl.translation[this.lang];
                                }
                            }
                        }
                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
                        finally {
                            try {
                                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                            }
                            finally { if (e_3) throw e_3.error; }
                        }
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        this.dialog.open(PropertyDetailDocumentPrintModuleDialogComponent, {
            data: {
                modalTitle: modalTitle,
                itemData: itemData,
                property: this.property,
                area: selectedArea && selectedArea.title ? selectedArea.title : "",
                docs: [{ title: modalTitle, subDoc: subArea, subAreaTitle: subAreaTitle }],
                structure: structure ? [{ name: structure }] : [],
            },
            width: "700px",
        });
    };
    /**
     * Handle side menu to expand panel
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.onItemOpen = function (item) {
        item.expanded = true;
        this.documentsStructure.forEach(function (el) {
            if (el.title !== item.title && el.expanded) {
                el.expanded = false;
            }
        });
    };
    /**
     * Handle side menu to close panel
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.onItemClose = function (item) {
        item.expanded = false;
    };
    /**
     * Handle click show documents not virtual
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.onShowDocsNotVirtual = function () {
        this.showDocumentsNotVirtual = true;
        this.documentArchiveIsLoading = true;
        var filteredData = [];
        if (this.allDocs && Array.isArray(this.allDocs)) {
            filteredData = this.filterDisplayedDocs(this.allDocs);
        }
        this.displayedDocs = filteredData;
        this.countDocPerArea();
        this.documentArchiveIsLoading = false;
    };
    /**
     * Handle click hide documents not virtual
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.onHideDocsNotVirtual = function () {
        this.showDocumentsNotVirtual = false;
        this.documentArchiveIsLoading = true;
        var filteredData = [];
        if (this.allDocs && Array.isArray(this.allDocs)) {
            filteredData = this.filterDisplayedDocs(this.allDocs);
        }
        this.displayedDocs = filteredData;
        this.countDocPerArea();
        this.documentArchiveIsLoading = false;
    };
    /**
     * Handle click show documents expired
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.onShowDocsExpired = function () {
        this.showDocumentsExpired = true;
        this.documentArchiveIsLoading = true;
        var filteredData = [];
        if (this.allDocs && Array.isArray(this.allDocs)) {
            filteredData = this.filterDisplayedDocs(this.allDocs);
        }
        this.displayedDocs = filteredData;
        this.countDocPerArea();
        this.documentArchiveIsLoading = false;
    };
    /**
     * Handle click hide documents expired
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.onHideDocsExpired = function () {
        this.showDocumentsExpired = false;
        this.documentArchiveIsLoading = true;
        var filteredData = [];
        if (this.allDocs && Array.isArray(this.allDocs)) {
            filteredData = this.filterDisplayedDocs(this.allDocs);
        }
        this.displayedDocs = filteredData;
        this.countDocPerArea();
        this.documentArchiveIsLoading = false;
    };
    /**
     * Handle click show documents not inserted
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.onShowDocsNotInserted = function () {
        this.showDocumentsNotInserted = true;
        this.documentArchiveIsLoading = true;
        var filteredData = [];
        if (this.allDocs && Array.isArray(this.allDocs)) {
            filteredData = this.filterDisplayedDocs(this.allDocs);
        }
        this.displayedDocs = filteredData;
        this.countDocPerArea();
        this.documentArchiveIsLoading = false;
    };
    /**
     * Handle click hide documents expired
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.onHideDocsNotInserted = function () {
        this.showDocumentsNotInserted = false;
        this.documentArchiveIsLoading = true;
        var filteredData = [];
        if (this.allDocs && Array.isArray(this.allDocs)) {
            filteredData = this.filterDisplayedDocs(this.allDocs);
        }
        this.displayedDocs = filteredData;
        this.countDocPerArea();
        this.documentArchiveIsLoading = false;
    };
    /**
     * Handle click show structure deleted
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.onShowStructureDeleted = function () {
        this.showStructureDeleted = true;
        this.documentArchiveIsLoading = true;
        var filteredData = [];
        if (this.allDocs && Array.isArray(this.allDocs)) {
            filteredData = this.filterDisplayedDocs(this.allDocs);
        }
        this.displayedDocs = filteredData;
        this.countDocPerArea();
        this.documentArchiveIsLoading = false;
    };
    /**
     * Handle click hide structure deleted
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.onHideStructureDeleted = function () {
        this.showStructureDeleted = false;
        this.documentArchiveIsLoading = true;
        var filteredData = [];
        if (this.allDocs && Array.isArray(this.allDocs)) {
            filteredData = this.filterDisplayedDocs(this.allDocs);
        }
        this.displayedDocs = filteredData;
        this.countDocPerArea();
        this.documentArchiveIsLoading = false;
    };
    /**
     * Does this node still own at least one document row?
     *
     * The side menu is built on allDocs, the archive on the tree returned by
     * filterDisplayedDocs, which prunes a deleted structure left without rows. Without this
     * check the menu would keep a voice pointing at a section the archive does not render.
     * A node owning no content array IS a document row: areas and sections own one.
     *
     * @since 3.0.0
     */
    PropertyDocumentsComponent.prototype.hasAnyDocument = function (node) {
        var _this = this;
        if (!node) {
            return false;
        }
        if (!Array.isArray(node.content)) {
            return true;
        }
        return node.content.some(function (child) { return _this.hasAnyDocument(child); });
    };
    /**
     * A soft deleted document row that the back end has already queued for the hard delete
     * cron. The queue (toHardDelete + hardDeleteDate) is written only by a manual user
     * deletion, never by the cascade that follows the removal of a mapping element, so this
     * is what tells the two kinds of soft deleted rows apart on this page.
     *
     * @since 3.0.0
     */
    PropertyDocumentsComponent.prototype.isPendingHardDelete = function (node) {
        return (node.deleted === true &&
            node.toHardDelete === true &&
            typeof node.hardDeleteDate !== "undefined" &&
            node.hardDeleteDate !== null &&
            node.hardDeleteDate !== "");
    };
    /**
     * Remove from the archive tree, in place, only the documents queued for the hard delete.
     *
     * The tree builder keeps every soft deleted document of a deleted structure
     * (documentTypes.ts, structureDocDeleted flag). Dropping all of them would hide the
     * deleted structures themselves, because the cascade of a removed mapping element soft
     * deletes all their documents: the node would be left empty and pruned by
     * filterDisplayedDocs. Only a manual deletion carries the hard delete queue, so this pass
     * still keeps a document deleted from this page out of the list, and out of the counters,
     * after the reload.
     * Only leaves are dropped: nodes owning a content array are areas or sections.
     *
     * @since 3.0.0
     */
    PropertyDocumentsComponent.prototype.removeHardDeletedDocs = function (nodes) {
        if (!Array.isArray(nodes)) {
            return;
        }
        for (var i = nodes.length - 1; i >= 0; i--) {
            var node = nodes[i];
            if (!node) {
                continue;
            }
            if (Array.isArray(node.content)) {
                this.removeHardDeletedDocs(node.content);
            }
            else if (this.isPendingHardDelete(node)) {
                nodes.splice(i, 1);
            }
        }
    };
    /**
     * Handle docs filtering
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.filterDisplayedDocs = function (docs) {
        var _this = this;
        // Shared & Temporary users
        if (this.loggedUserShared || this.loggedUserTemporary) {
            switch (docs.keyTranslateTitle) {
                case "properties.documents.gestionaleAmministrativo":
                    if (!this.currentRole.propertiesPermission.gestionaleAmministrativo) {
                        return {};
                    }
                    break;
                case "properties.documents.verbaliconvocazioni":
                    if (!this.currentRole.propertiesPermission.gestionaleContabile) {
                        return {};
                    }
                    break;
                case "properties.documents.urbanisticaEdEdilizia":
                    if (!this.currentRole.propertiesPermission.urbanisticaEdEdilizia) {
                        return {};
                    }
                    break;
                case "properties.documents.catasto":
                    if (!this.currentRole.propertiesPermission.catasto) {
                        return {};
                    }
                    break;
                case "properties.documents.locazioneContrdiLocazione":
                    if (!this.currentRole.propertiesPermission.contratti) {
                        return {};
                    }
                    break;
                case "properties.documents.contratti":
                    if (!this.currentRole.propertiesPermission.contratti) {
                        return {};
                    }
                    break;
                case "properties.documents.lineaVita":
                    if (!this.currentRole.propertiesPermission.lineaVita) {
                        return {};
                    }
                    break;
                case "properties.documents.amiantoDoc":
                    if (!this.currentRole.propertiesPermission.amiantoDoc) {
                        return {};
                    }
                    break;
                case "properties.documents.edile":
                    if (!this.currentRole.propertiesPermission.edile) {
                        return {};
                    }
                    break;
                case "properties.documents.impiantoElettrico":
                    if (!this.currentRole.propertiesPermission.impiantoElettrico) {
                        return {};
                    }
                    break;
                case "properties.documents.riscaldamentoCondizionamento":
                    if (!this.currentRole.propertiesPermission.riscaldamentoCondizionamento) {
                        return {};
                    }
                    break;
                case "properties.documents.ascensoriEMontauto":
                    if (!this.currentRole.propertiesPermission.ascensori) {
                        return {};
                    }
                    break;
                case "properties.documents.trattamentoAcqua":
                    if (!this.currentRole.propertiesPermission.trattamentoAcqua) {
                        return {};
                    }
                    break;
                case "properties.documents.impiantiElettronici":
                    if (!this.currentRole.propertiesPermission.impiantiElettronici) {
                        return {};
                    }
                    break;
                case "properties.documents.attivitaSottopostePrevenzioneIncendi":
                    if (!this.currentRole.propertiesPermission.antincendio) {
                        return {};
                    }
                    break;
                case "properties.documents.impiantiAntincendio":
                    if (!this.currentRole.propertiesPermission.antincendio) {
                        return {};
                    }
                    break;
                case "properties.documents.impiantiSpeciali":
                    if (!this.currentRole.propertiesPermission.impiantiSpeciali) {
                        return {};
                    }
                    break;
                case "properties.documents.impiantiRicreativiSportivi":
                    if (!this.currentRole.propertiesPermission.impiantiRicreativiSportivi) {
                        return {};
                    }
                    break;
                case "properties.documents.R6manutenzioni":
                    if (!this.currentRole.propertiesPermission.preventivi) {
                        return {};
                    }
                    break;
                case "properties.documents.unitaImmobiliari":
                    if (!this.currentRole.propertiesPermission.unitaImmobiliari) {
                        return {};
                    }
                    break;
            }
        }
        if (typeof docs.active !== "undefined" &&
            !docs.active &&
            !this.showStructureDeleted) {
            return {};
        }
        // Deleted structure left without documents (all of them queued for the hard delete and
        // removed by removeHardDeletedDocs): the empty node would fall through to the leaf branch
        // below and be rendered as a section header with no rows under it.
        if (typeof docs.active !== "undefined" &&
            !docs.active &&
            Array.isArray(docs.content) &&
            !docs.content.length) {
            return {};
        }
        if (docs.content && Array.isArray(docs.content) && docs.content.length) {
            var values = {};
            var contents = this.filterDisplayedDocs(docs.content);
            if (contents && Array.isArray(contents) && contents.length) {
                values = {
                    active: docs.active,
                    content: contents,
                    docId: docs.docId,
                    structureId: docs.structureId,
                    keyTranslateTitle: docs.keyTranslateTitle,
                    title: docs.title,
                    type: docs.type,
                };
            }
            return values;
        }
        else {
            if (docs && Array.isArray(docs) && docs.length) {
                var content_1 = [];
                docs.forEach(function (docs) {
                    var ret = _this.filterDisplayedDocs(docs);
                    if (!(Object.keys(ret).length === 0 && ret.constructor === Object) &&
                        ret !== "") {
                        content_1.push(ret);
                    }
                });
                return content_1;
            }
            else {
                var found = false;
                if (this.showDocumentsNotInserted &&
                    this.showDocumentsExpired &&
                    this.showDocumentsNotVirtual) {
                    // show all docs
                    found = true;
                }
                else if (!this.showDocumentsNotInserted &&
                    this.showDocumentsExpired &&
                    this.showDocumentsNotVirtual) {
                    // show only inserted docs
                    if (docs.data) {
                        found = true;
                    }
                }
                else if (this.showDocumentsNotInserted &&
                    !this.showDocumentsExpired &&
                    this.showDocumentsNotVirtual) {
                    // show all docs not expired
                    if (!docs.expired) {
                        found = true;
                    }
                }
                else if (!this.showDocumentsNotInserted &&
                    !this.showDocumentsExpired &&
                    this.showDocumentsNotVirtual) {
                    // show only inserted docs and not expired
                    if (docs.data && !docs.expired) {
                        found = true;
                    }
                }
                else if (!this.showDocumentsNotVirtual) {
                    // show only virtual
                    if (docs.mockup) {
                        found = true;
                    }
                }
                // Only Privacy
                if (this.subscriptionType === 'PRIVACY' &&
                    !this.loggedUserAdmin &&
                    !docs.privacy) {
                    found = false;
                }
                if (found) {
                    return docs;
                }
            }
        }
        return "";
    };
    /**
     * Handle click to show document notes
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.onViewDocumentNotes = function () {
        var _this = this;
        var note = [];
        if (this.condoStructure) {
            var _loop_7 = function (key) {
                var e_4, _a, e_5, _b;
                if (Array.isArray(this_2.condoStructure[key]) &&
                    this_2.condoStructure[key].length) {
                    var structureTranslated_1 = '';
                    var find = false;
                    var structureTemplate = JSON.parse(JSON.stringify(this_2.condoStructureTemplate));
                    if (structureTemplate && Array.isArray(structureTemplate)) {
                        try {
                            for (var structureTemplate_1 = (e_4 = void 0, tslib_1.__values(structureTemplate)), structureTemplate_1_1 = structureTemplate_1.next(); !structureTemplate_1_1.done; structureTemplate_1_1 = structureTemplate_1.next()) {
                                var level1 = structureTemplate_1_1.value;
                                if (level1.content && Array.isArray(level1.content)) {
                                    try {
                                        for (var _c = (e_5 = void 0, tslib_1.__values(level1.content)), _d = _c.next(); !_d.done; _d = _c.next()) {
                                            var level2 = _d.value;
                                            // if (level2.title === `properties.structures.${key}`) {
                                            if (level2.key === key) {
                                                structureTranslated_1 = level2.translation[this_2.lang];
                                                find = true;
                                                break;
                                            }
                                        }
                                    }
                                    catch (e_5_1) { e_5 = { error: e_5_1 }; }
                                    finally {
                                        try {
                                            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                                        }
                                        finally { if (e_5) throw e_5.error; }
                                    }
                                }
                                if (find) {
                                    break;
                                }
                            }
                        }
                        catch (e_4_1) { e_4 = { error: e_4_1 }; }
                        finally {
                            try {
                                if (structureTemplate_1_1 && !structureTemplate_1_1.done && (_a = structureTemplate_1.return)) _a.call(structureTemplate_1);
                            }
                            finally { if (e_4) throw e_4.error; }
                        }
                    }
                    this_2.condoStructure[key].forEach(function (el, index) {
                        if (el.active && el.note && Array.isArray(el.note) && el.note.length) {
                            el.note.forEach(function (subEl, indexNote) {
                                note.push({
                                    createdAt: subEl.createdAt,
                                    createdBy: subEl.createdBy.firstName + " " + subEl.createdBy.lastName,
                                    text: subEl.text,
                                    name: el.nome ? el.nome : "",
                                    // structure: this.translateService.instant(
                                    //   "properties.structures." + key
                                    // ),
                                    structure: structureTranslated_1,
                                    structureName: key,
                                    structurePosition: index,
                                    structureId: el._id,
                                    notePosition: indexNote,
                                    noteId: subEl._id,
                                });
                            });
                        }
                    });
                }
            };
            var this_2 = this;
            for (var key in this.condoStructure) {
                _loop_7(key);
            }
        }
        var noteDialogRef = this.dialog.open(PropertyDetailDocumentNoteDialogComponent, {
            data: {
                modalTitle: this.translateService.instant("properties.documentsPage.noteList"),
                condoStructureId: this.condoStructure._id,
                notes: note,
            },
            minWidth: "50%",
        });
        noteDialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (res && res.reload) {
                _this.getStructureData();
            }
        });
    };
    /**
     * Export properties in a file with given format
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.onExport = function (target, propertyId) {
        var _this = this;
        // If target is not provided, than just export all properties
        if (!target) {
            var date = formatDate(new Date(), "yyyyMMddhhmmss", "en-EN");
            var fileName_1 = this.translateService.instant("properties.list.exportFileName") + " " + date;
            this.subscriptions.push(this.propertiesService.getExport().subscribe(function (res) {
                var fileBlob = res;
                var blob = new Blob([fileBlob], {
                    type: "application/vnd.ms-excel",
                });
                FileSaver.saveAs(blob, fileName_1 + ".xlsx");
            }, function (err) {
                _this.helperService.handleError(err);
            }));
        }
        else if (target && typeof propertyId !== "undefined") {
            // Handle export for missing/inserted documents
            var date = formatDate(new Date(), "yyyyMMddhhmmss", "en-EN");
            var fileName_2 = this.translateService.instant("properties.list." + target) + " " + date;
            this.subscriptions.push(this.propertiesService.getDocExport(target, propertyId).subscribe(function (res) {
                var fileBlob = res;
                var blob = new Blob([fileBlob], {
                    type: "application/vnd.ms-excel",
                });
                FileSaver.saveAs(blob, fileName_2 + ".xlsx");
            }, function (err) {
                _this.helperService.handleError(err);
            }));
        }
    };
    /**
     * Handle scroll to selected title
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.onTitleClicked = function (rawTitle) {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        setTimeout(function () {
            // const title = this.translateService.instant(rawTitle);
            var docsWindow = document.getElementById("doc-wrapper");
            var target = document.getElementById(rawTitle);
            var top = target.offsetTop;
            docsWindow.scrollTo({
                top: top,
                behavior: "smooth",
            });
        }, 500);
    };
    /**
     * Send docs by email
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.onSendByEmail = function () {
        var _this = this;
        if (!this.selectedDocs.length) {
            this.toastrService.error(this.translateService.instant("common.errors.chooseElementFirst"));
            return;
        }
        if (this.selectedDocs.length > this.configService.maximumNumberOfAttachmentsPerEmail) {
            this.toastrService.error(this.translateService.instant("common.warnings.maximumAttachmentsReached", {
                max: this.configService.maximumNumberOfAttachmentsPerEmail
            }));
            return;
        }
        // Open dialog
        var newMessageDialogRef = this.newMessageDialog.open(SendEmailDialogComponent, {
            minWidth: "60%",
            maxHeight: "98vh",
            data: {
                phonebook: this.company.get("phonebook")
                    ? this.company.get("phonebook")
                    : [],
                insertedDocs: this.insertedDocs,
                selectedDocs: this.selectedDocs,
                companyData: this.loggedUserMaster ? this.companyData : "",
                propertyName: this.propertyData.name,
                propertyId: this.propertyId,
                sentFromSupplierPage: false,
            },
            disableClose: true,
        });
        // Subscribe to dialog result (only for 1 emit thanks to "take()")
        newMessageDialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            _this.toastrService.success(_this.translateService.instant("communications.add.sendedSuccessfully"));
        });
    };
    /**
     * Update docs array with incoming element
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.onDocSelected = function (doc, checked) {
        if (doc && checked) {
            this.selectedDocs.push(doc.value.docId);
            if (this.selectedDocs.length > this.configService.maximumNumberOfAttachmentsPerEmail) {
                this.toastrService.error(this.translateService.instant("common.warnings.maximumAttachmentsReached", {
                    max: this.configService.maximumNumberOfAttachmentsPerEmail
                }));
            }
        }
        else if (doc && !checked) {
            var index = this.selectedDocs.indexOf(doc.value.docId);
            this.selectedDocs.splice(index, 1);
        }
    };
    /**
     * Update docs array with incoming element
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.onAllDocsSelected = function (docs, event) {
        // event.
        // if (doc && checked) {
        //   this.selectedDocs.push(doc.value.docId);
        // } else if (doc && !checked) {
        //   const index = this.selectedDocs.indexOf(doc.value.docId);
        //   this.selectedDocs.splice(index, 1);
        // }
    };
    /**
     * Auto-select checkboxes of same sub-group
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.onAllSubDocsSelected = function (items, checked) {
        var _this = this;
        var add = false;
        if (items && items.length) {
            items.forEach(function (item) {
                if (item.data && item.data.document) {
                    item.checked = checked;
                    if (checked) {
                        add = true;
                        _this.selectedDocs.push(item.docId);
                    }
                    else if (!checked) {
                        var index = _this.selectedDocs.indexOf(item.docId);
                        _this.selectedDocs.splice(index, 1);
                    }
                }
            });
            if (add && this.selectedDocs.length > this.configService.maximumNumberOfAttachmentsPerEmail) {
                this.toastrService.error(this.translateService.instant("common.warnings.maximumAttachmentsReached", {
                    max: this.configService.maximumNumberOfAttachmentsPerEmail
                }));
            }
        }
    };
    /**
     * Handle table sort
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.sortData = function (sort, i, t, x, pos) {
        var _this = this;
        var sortedData = [];
        if (pos === "1") {
            sortedData = this.displayedDocs[i].content[t].content[x].content;
        }
        else if (pos === "2") {
            sortedData = this.displayedDocs[i].content[t].content;
        }
        else if (pos === "3") {
            sortedData = this.displayedDocs[i].content;
        }
        if (!this.sortActive) {
            this.currentOriginalOrder = JSON.parse(JSON.stringify(sortedData));
        }
        var data = sortedData;
        if (!sort.active || sort.direction === "") {
            sortedData = this.currentOriginalOrder;
            if (pos === "1") {
                this.displayedDocs[i].content[t].content[x].content = sortedData;
            }
            else if (pos === "2") {
                this.displayedDocs[i].content[t].content = sortedData;
            }
            else if (pos === "3") {
                this.displayedDocs[i].content = sortedData;
            }
            this.sortActive = false;
            return;
        }
        sortedData = data.sort(function (a, b) {
            var isAsc = sort.direction === "asc";
            switch (sort.active) {
                case "title":
                    return _this.compare(a.title.toLowerCase(), b.title.toLowerCase(), isAsc);
                case "data.contenutoDocumento":
                    var aContenutoDocumento = a.data && a.data.contenutoDocumento
                        ? a.data.contenutoDocumento.toLowerCase()
                        : "";
                    var bContenutoDocumento = b.data && b.data.contenutoDocumento
                        ? b.data.contenutoDocumento.toLowerCase()
                        : "";
                    return _this.compare(aContenutoDocumento, bContenutoDocumento, isAsc);
                case "data.ragioneSocialeFornitore":
                    var aRagioneSocialeFornitore = a.data && a.data.ragioneSocialeFornitore
                        ? a.data.ragioneSocialeFornitore
                        : "";
                    var bRagioneSocialeFornitore = b.data && b.data.ragioneSocialeFornitore
                        ? b.data.ragioneSocialeFornitore
                        : "";
                    return _this.compare(aRagioneSocialeFornitore, bRagioneSocialeFornitore, isAsc);
                case "data.dataDocumento":
                    var aDataDocumento = a.data && a.data.dataDocumento ? a.data.dataDocumento : "";
                    var bDataDocumento = b.data && b.data.dataDocumento ? b.data.dataDocumento : "";
                    return _this.compare(aDataDocumento, bDataDocumento, isAsc);
                case "dateExpired":
                    var aDateExpired = a.dateExpired ? a.dateExpired : "";
                    var bDateExpired = b.dateExpired ? b.dateExpired : "";
                    return _this.compare(aDateExpired, bDateExpired, isAsc);
                case "data.docCode":
                    var aDocCode = a.data && a.data.docCode ? a.data.docCode : "";
                    var bDocCode = b.data && b.data.docCode ? b.data.docCode : "";
                    return _this.compare(aDocCode, bDocCode, isAsc);
                default:
                    return 0;
            }
        });
        if (pos === "1") {
            this.displayedDocs[i].content[t].content[x].content = sortedData;
        }
        else if (pos === "2") {
            this.displayedDocs[i].content[t].content = sortedData;
        }
        else if (pos === "3") {
            this.displayedDocs[i].content = sortedData;
        }
        this.sortActive = true;
    };
    /**
     * Utility per table sort
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.compare = function (a, b, isAsc) {
        return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    };
    /**
     * Open view structure dialog
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.onViewStructureDialogOpen = function () {
        var width = window.innerWidth < 1280 ? "90vw" : "80vw";
        // const dialogRef =
        this.dialog.open(ViewStructureDialogComponent, {
            data: {
                modalTitle: this.translateService.instant("properties.addDocumentsPage.viewStructureDialog.title"),
                condoStructure: this.condoStructure,
                property: this.property,
                propertyData: this.propertyData,
            },
            width: width,
            maxWidth: width,
        });
    };
    /**
     * Handle click on document form to expire contract
     * itemData: data value of the document
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.onHandleExpiredContract = function (itemData) {
        var _this = this;
        var dialogRef = this.dialog.open(PropertyExpireContractItemDialogComponent, {
            data: {
                documentArchiveId: this.documentArchiveId,
                barCode: itemData.barCode ? itemData.barCode : '',
            },
            width: "600px",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            else {
                // recreate view of all docs to show new inserted doc
                _this.allDocs = [];
                if (_this.subscriptionType === "FREE" || _this.subscriptionType === "FREEBASIC") {
                    _this.getDocumentArchiveDataFree();
                }
                else {
                    _this.getDocumentArchiveData();
                }
            }
        }, function (err) {
            _this.helperService.handleError(err);
        });
    };
    /**
     * Handle click on document form to delete file
     * modalTitle: title of dialogbox from document name
     * documentKey: doc type, es. AA1, AA2, etc.
     * documentId: the ID of document into array of documentArchive section (es. gestAmmTivoDipendenti)
     * subDocumentId: the ID of sub document into array of docs type (es. AA1)
     * itemData: data value of form items
     * action: edito or show doc data
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.onCancelContractDialogOpen = function (keyTranslateTitle, modalTitle, structureId, documentKey, documentId, subDocumentId, itemData) {
        var _this = this;
        var contract = tslib_1.__assign({}, itemData, { documentArchiveId: this.documentArchiveId, title: modalTitle, companyData: this.loggedUserMaster ? this.companyData : "", propertyName: this.propertyName, propertyId: this.propertyId });
        // Open dialog
        var dialogRef = this.cancelContractDialog.open(CancelContractDialogComponent, {
            minWidth: "60%",
            maxHeight: "98vh",
            data: {
                contract: contract,
                subject: this.translateService.instant("communications.fields.cancelContractSubject"),
                body: this.translateService.instant("communications.fields.cancelContractImmediateBody", { title: modalTitle.trim() }),
            },
            disableClose: true,
        });
        // On dialog closing, let's update model
        this.subscriptions.push(dialogRef.afterClosed().subscribe(function (res) {
            if (res) {
                var sendData = {
                    msg: res,
                };
                _this.subscriptions.push(_this.documentArchivesService
                    .cancelContract(_this.documentArchiveId, sendData)
                    .pipe(take(1))
                    .subscribe(function (res) {
                    if (!res) {
                        return;
                    }
                    else {
                        // recreate view of all docs to show new inserted doc
                        _this.allDocs = [];
                        if (_this.subscriptionType === "FREE" || _this.subscriptionType === "FREEBASIC") {
                            _this.getDocumentArchiveDataFree();
                        }
                        else {
                            _this.getDocumentArchiveData();
                        }
                    }
                }, function (err) {
                    _this.helperService.handleError(err);
                }));
            }
            else {
                // console.warn("TASTO CHIUDI")
            }
        }, function (err) {
            _this.helperService.handleError(err);
        }));
    };
    /**
     * Word contracts export
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.onExportContracts = function () {
        var dialogRef = this.dialog.open(ExportContractsDialogComponent, {
            minWidth: "50%",
            maxHeight: "98vh",
            data: {
                propertyId: this.propertyId,
            },
            disableClose: true,
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            return;
        });
    };
    /**
     * RAS docs export in PDF format
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.onExportRAS = function () {
        var dialogRef = this.dialog.open(ExportRasDocsDialogComponent, {
            width: "700px",
            data: {
                propertyId: this.propertyId,
            },
            disableClose: true,
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            return;
        });
    };
    /**
     * CPI: disable document
     */
    PropertyDocumentsComponent.prototype.onDisableCPIDocument = function (element) {
        var _this = this;
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant('properties.documentsPage.dialog.disbaleDoc.title'),
                message: this.translateService.instant('properties.documentsPage.dialog.disbaleDoc.message'),
                btnOkText: this.translateService.instant('common.cta.confirm'),
                btnCancelText: this.translateService.instant('common.cta.close'),
            },
            width: '500px',
            disableClose: true
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            var sendData = {
                subDocId: element.docId
            };
            _this.subscriptions.push(_this.documentArchivesService
                .disableDocument(_this.documentArchiveId, sendData)
                .pipe(take(1))
                .subscribe(function (res) {
                if (!res) {
                    return;
                }
                else {
                    // recreate view of all docs to show new inserted doc
                    _this.allDocs = [];
                    if (_this.subscriptionType === "FREE" || _this.subscriptionType === "FREEBASIC") {
                        _this.getDocumentArchiveDataFree();
                    }
                    else {
                        _this.getDocumentArchiveData();
                    }
                }
            }, function (err) {
                _this.helperService.handleError(err);
            }));
        });
    };
    /**
     * Open the "Gestione Nome Archiviazione Intervento" dialog.
     *
     * It manages the archive-wide list of "interventi di archiviazione"
     * (create / rename / delete). The list is a single flat list shared by the
     * three subareas that group documents by intervention ("Cause legali",
     * "Interventi successivi", "Pratiche edilizie"): there is no notion of an
     * intervention belonging to a single subarea.
     *
     * Reserved to Admin/Operator roles - the menu entry is gated the same way.
     * The guard below only covers other call paths: the real enforcement stays
     * on the back-end.
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.onManageInterventionArchiving = function () {
        var _this = this;
        if (!this.loggedUserAdmin ||
            !this.loggedUserPermissions.includes("canCreateDocuments")) {
            this.toastrService.error(this.translateService.instant("common.errors.not_authorized"));
            return;
        }
        if (!this.documentArchiveId) {
            this.toastrService.error(this.translateService.instant("properties.documentsPage.interventionArchiving.errors.archiveNotFound"));
            return;
        }
        var dialogRef = this.dialog.open(InterventionArchivingDialogComponent, {
            data: {
                documentArchiveId: this.documentArchiveId,
                propertyName: this.property.get("name"),
                interventions: Array.isArray(this.nameInterventionArchiving)
                    ? this.nameInterventionArchiving
                    : [],
                documentCounts: this.getInterventionDocumentCounts(),
            },
            width: "780px",
            maxHeight: "92vh",
            disableClose: true,
        });
        this.subscriptions.push(dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            // Something changed on the back-end: the whole tree must be rebuilt
            // because a rename cascades on every linked document
            _this.allDocs = [];
            if (_this.subscriptionType === "FREE" ||
                _this.subscriptionType === "FREEBASIC") {
                _this.getDocumentArchiveDataFree();
            }
            else {
                _this.getDocumentArchiveData();
            }
        }));
    };
    /**
     * Derive the document count per intervention name out of the already-built
     * archive tree. Only the three subareas that group documents by
     * intervention are inspected: their children hold the intervention name as
     * "title" and the related documents in "content".
     *
     * The result is a LOWER BOUND: the tree only holds non-deleted documents
     * while the back-end counts every document (deleted ones and mockups
     * included), so a zero count does NOT guarantee the deletion is accepted.
     * The dialog handles the 409 anyway.
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.getInterventionDocumentCounts = function () {
        var interventionSubAreas = [
            "properties.documents.gestAmmTivoCauseLegali",
            "properties.documents.edileinterventiSuccessivi",
            "properties.documents.DpraticheEdilizie",
        ];
        // Null-prototype map: the keys are free text typed by the users
        var counts = Object.create(null);
        if (!Array.isArray(this.allDocs)) {
            return counts;
        }
        this.allDocs.forEach(function (area) {
            if (!area || !Array.isArray(area.content)) {
                return;
            }
            area.content.forEach(function (subArea) {
                if (!subArea ||
                    typeof subArea.keyTranslateTitle !== "string" ||
                    !Array.isArray(subArea.content) ||
                    interventionSubAreas.indexOf(subArea.keyTranslateTitle) === -1) {
                    return;
                }
                subArea.content.forEach(function (group) {
                    if (!group || typeof group.title !== "string") {
                        return;
                    }
                    var docsAmount = Array.isArray(group.content)
                        ? group.content.length
                        : 0;
                    var current = Object.prototype.hasOwnProperty.call(counts, group.title)
                        ? counts[group.title]
                        : 0;
                    counts[group.title] = current + docsAmount;
                });
            });
        });
        return counts;
    };
    /**
     * Open the "Gestione Nome Conduttore" dialog.
     *
     * Twin of onManageInterventionArchiving(): it manages the archive-wide list
     * of "conduttori" (`conductorName`), shared by the whole archive and not
     * scoped to a subarea.
     *
     * Reserved to Admin/Operator roles - the menu entry is gated the same way.
     * The guard below only covers other call paths: the real enforcement stays
     * on the back-end.
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.onManageConductors = function () {
        var _this = this;
        if (!this.loggedUserAdmin ||
            !this.loggedUserPermissions.includes("canCreateDocuments")) {
            this.toastrService.error(this.translateService.instant("common.errors.not_authorized"));
            return;
        }
        if (!this.documentArchiveId) {
            this.toastrService.error(this.translateService.instant("properties.documentsPage.conductorManagement.errors.archiveNotFound"));
            return;
        }
        var dialogRef = this.dialog.open(ConductorManagementDialogComponent, {
            data: {
                documentArchiveId: this.documentArchiveId,
                propertyName: this.property.get("name"),
                conductors: Array.isArray(this.conductorName)
                    ? this.conductorName
                    : [],
                documentCounts: this.getConductorDocumentCounts(),
            },
            width: "780px",
            maxHeight: "92vh",
            disableClose: true,
        });
        this.subscriptions.push(dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            // Something changed on the back-end: the whole tree must be rebuilt
            // because a rename cascades on every linked document
            _this.allDocs = [];
            if (_this.subscriptionType === "FREE" ||
                _this.subscriptionType === "FREEBASIC") {
                _this.getDocumentArchiveDataFree();
            }
            else {
                _this.getDocumentArchiveData();
            }
        }));
    };
    /**
     * Derive the document count per conductor out of the already-built archive
     * tree. Only "Contratti di locazione" groups documents by conductor: its
     * children hold the conductor name as "title" and the related documents in
     * "content".
     *
     * The result is a LOWER BOUND: the tree only holds non-deleted documents
     * while the back-end counts every document (deleted, expired and mockups
     * included), so a zero count does NOT guarantee the deletion is accepted.
     * The dialog handles the 409 anyway.
     *
     * @since 1.0.0
     */
    PropertyDocumentsComponent.prototype.getConductorDocumentCounts = function () {
        var conductorSubArea = "properties.documents.locazioneContrdiLocazione";
        // Null-prototype map: the keys are free text typed by the users
        var counts = Object.create(null);
        if (!Array.isArray(this.allDocs)) {
            return counts;
        }
        this.allDocs.forEach(function (area) {
            if (!area || !Array.isArray(area.content)) {
                return;
            }
            area.content.forEach(function (subArea) {
                if (!subArea ||
                    subArea.keyTranslateTitle !== conductorSubArea ||
                    !Array.isArray(subArea.content)) {
                    return;
                }
                subArea.content.forEach(function (group) {
                    if (!group || typeof group.title !== "string") {
                        return;
                    }
                    var docsAmount = Array.isArray(group.content)
                        ? group.content.length
                        : 0;
                    var current = Object.prototype.hasOwnProperty.call(counts, group.title)
                        ? counts[group.title]
                        : 0;
                    counts[group.title] = current + docsAmount;
                });
            });
        });
        return counts;
    };
    return PropertyDocumentsComponent;
}());
export { PropertyDocumentsComponent };
